const zh_TW = {
  // 共用區
  tag_name: '標籤名稱',
  property: '屬性',
  endpoint: '終端',
  protocol: '通訊協定',
  parameters: '參數',
  items: '{item}',
  delete_msg: '您確定要刪除此{item} 嗎?',
  this_field_is_required: '此欄位必填',
  external_address: '外部地址',
  internal_address: '内部地址',
  port: '連接埠',
  name_validate_error_msg: '只允许 0-9 a-z A-Z . _ 和 -',
  edit: '編輯',
  name: '名稱',
  description: '描述',
  created_time: '建立時間',
  status: '狀態',
  delete: '刪除',
  please_select_service: '請選擇服務',
  management: '管理中心',
  console: '主控臺',
  lang: '語言',
  catalog: '應用商店',
  address: '地址',
  alternative_email: '備用信箱',
  billing: '費用',
  cluster: '叢集',
  city: '城市',
  company: '公司',
  config: '配置',
  confirm: '確定',
  contact_phone: '聯絡電話',
  contact_technical_support: '聯絡技術支援',
  country_region: '國家/地區',
  create: '建立',
  create_time: '建立時間',
  delete_role: '確定要刪除此角色嗎？',
  delete_roles: '確定要刪除這些角色嗎？',
  delete_user: '您確定要刪除{name}嗎？',
  disabled: '停用',
  enabled: '啟用',
  delete_service: '刪除服務',
  empty: '空',
  first_name: '名字',
  highest_role: '最高權限',
  industry: '行業',
  invite: '邀請',
  last_login: '上次登入',
  last_name: '姓氏',
  license_invalid: '無效的授權或授權已過期',
  loading: '載入中',
  namespace: '命名空間',
  not_login: '尚未登入',
  order: '訂單',
  path: '路徑',
  p_s_rc: '請選擇國家或地區',
  quota: '配額',
  resources_mgmt: '資源管理',
  resources_permission_exist: '資源權限已存在',
  role_permission_exist: '角色權限已存在',
  resource_permissions_sub: '建立、分配和管理使用者資源權限和角色',
  role: '角色',
  rules: '規則',
  save: '儲存',
  select_role: '請選擇角色',
  service: '服務',
  services: '服務',
  services_list: '服務管理包括：顯示各應用組中的服務列表及詳細資訊，服務註冊，服務地址是否暴露至公共服務列表和服務健康檢查等功能。',
  success_save: '儲存成功',
  service_property: '服務屬性',
  support_message: '如果您遇到問題需要技術支援，請寄送電子郵件至',
  source: '來源',
  stop: '停止',
  tickets: '工作訂單',
  type: '類型',
  user_base_info: '使用者基本資訊',
  user_center: '使用者中心',
  user_info: '使用者資訊',
  user_info_sub: '使用者的基本資訊與權限',
  username: '使用者名稱',
  workspace: '工作空間',
  resource: '資源',
  add: '新增',
  events: '事件',
  refresh: '重新整理',
  remember_me: '記住我',
  search: '搜尋',
  subscription_name: '訂閱號名稱',
  total_items: '共 {value} 條',
  user: '使用者',
  view: '查看',
  activation_code: '啟動碼',
  back: '返回',
  bind: '綁定',
  bind_sso: '綁定 EnSaaS SSO 帳號',
  change: '修改',
  change_pwd: '更改密碼',
  change_pwd_sub: '首次更改登入密碼，請參考密碼字元',
  confirm_info: '「確認」點擊確認即表示您同意建立SSO帳號',
  create_info:
    '我們將為您生成一組EnSaaS SSO 帳號並與您的MyAdvantech 帳號綁定在一起，EnSaaS 訂閱號與MyAdvantech Account 綁定。綁定後，您將收到一封EnSaaS SSO 帳號註冊信，請根據註冊信中的提示登入 EnSaaS Portal 並修改您的密碼。',
  creation_time: '建立時間',
  delete_users: '您確定要刪除這些使用者嗎？',
  disable: '禁用',
  disable_user: '您確定要禁用此使用者嗎？',
  disable_users: '您確定要禁用這些使用者嗎？',
  delete_item: '刪除 {type}',
  enable: '啟用',
  enable_user: '您確定要啟用此使用者嗎？',
  enable_users: '您確定要啟用這些使用者嗎？',
  export: '匯出',
  help: '幫助',
  home: '主頁',
  id: 'ID',
  member: '成員',
  node_type: '節點類型',
  or_sign_in_with: '或登入用',
  origin: '來源',
  password_error: '密碼錯誤',
  password_check_email: '請查看郵件，輸入正確的密碼',
  p_c_pwd: '請檢查密碼',
  p_i_activation_code: '請輸入啟動碼！',
  p_i_password: '請輸入密碼',
  p_i_phone: '請輸入手機號碼',
  p_i_n_pwd: '請輸入新密碼',
  p_i_n_pwd_a: '請再次輸入新密碼',
  pwd_policy: '密碼規則',
  pwd_p_1: '至少8個字元',
  pwd_p_2: '至少1位數',
  pwd_p_3: '至少1個小寫字母',
  pwd_p_4: '至少1個大寫字母',
  pwd_p_5: '至少1個特殊字元',
  pwd_p_6: "除了空格（），反斜線（\\）和雙引號（“）'）",
  retry: '重試',
  reset: '重置',
  resend_code: '重新發送驗證碼',
  resend_email: '重新發送郵件',
  resend_email_info:
    '如果您在註冊完成後仍未收到註冊電子郵件，則可以使用此工具重新發送。 提交後，您將收到一封電子郵件，其中包含完成該過程的連結。要重新發送註冊電子郵件，請輸入您的使用者名稱（Email），然後按一下“提交”。',
  resend_email_sub: '輸入電子郵件以重新發送註冊電子郵件',
  resend_email_success: '成功重新發送註冊電子郵件。 頁面將在5秒鐘後跳轉。',
  reset_pwd_valid: '重置密碼有效',
  reset_pwd_success: '更改密碼成功。',
  send_pwd_email_success: '成功發送密碼重置電子郵件。 頁面將在5秒鐘後跳轉。',
  select_dc: '請選擇資料中心',
  select_cluster: '請選擇叢集',
  select_ws: '請選擇工作空間',
  select_ns: '請選擇命名空間',
  setting: '設置',
  success: '成功',
  submit: '提交',
  subscription: '訂閱號',
  subscription_info: '訂閱號資訊',
  subscriptions: '訂閱號',
  system_notification_sub: '由於是首次登入，我們建議您立即更改預設密碼。',
  two_pwd_unequal: '您輸入的兩個密碼不一致！',
  update: '更新',
  user_id: '使用者ID',
  username_email: '使用者名稱(電子信箱)',
  verify: '驗證',
  version: '版本',
  warning: '警告',
  web_kubectl: 'Web Kubectl',
  all: '全部',
  cancel: '取消',
  backup_restore: '備份還原',
  products: '服務目錄',
  update_time: '更新時間',
  secret: '金鑰',
  value: '值',
  operation_type: '操作類型',
  operation_records: '操作記錄',
  action: '操作',
  pn: '料號',
  dataCenter: '站點',
  no_data: '無資料',
  please_input: '請輸入{type}名稱',
  ingress: 'Ingress',
  batch_assign: '批次映射',
  notification: '通知',
  send_verify_code: '發送驗證碼',
  p_i_first_name: '請輸入名字',
  p_i_last_name: '請輸入姓氏',
  verify_code: '驗證碼',
  whitelist: '白名單',
  remove: '移除',
  batch_delete: '批次刪除',
  successfully: '成功',
  error: '失敗',
  created: '建立',
  updated: '更新',
  deleted: '刪除',
  'please_input_ ': '請輸入',

  // 列表表格
  // refresh: '重新整理',
  // all: '全部',

  // 彈出視窗
  ok: '確定',
  // cancel: '取消',
  operation: '操作',
  this_name_has_been_existed: '此名稱已存在',
  //   name_validate_error_msg: '只允許 0-9 a-z A-Z . 和 -',
  should_not_be_at_the_beginning_or_end: '特殊字元 .- 不能在名稱開頭或結尾',

  // 登入頁面
  /*
  registered: '註 冊',
  registered_title: '註 冊',
  registered_success: '註冊成功！',
  sign_in: '登入',
  forgot_pwd: '忘記密碼',
  retrieve_password: '檢索密碼',
  retrieve_password_sub: '輸入您的電子郵件位址。稍後將發送驗證碼。',
  r_to_login: '返回登入頁面',
  p_i_username_e: '請輸入使用者名稱(電子郵件)',
  send_pwd_email: '發送密碼重置電子郵件',
  send_pwd_email_sub: '如果您忘記了密碼,您可以使用此工具重置密碼。提交後,您將收到一封電子郵件驗證碼,並包含完成該過程的連結。',
  sign_in_sub: '登入到開發人員網路',
  skip: '跳過',
  go_to_change_pwd: '轉到更改密碼',
  system_notification: '系統通知',
  password: '密碼',
  p_i_pwd: '請輸入您的密碼',
  p_i_username: '請輸入您的使用者名稱',
  not_receive_email: '收不到電子郵件',
  draft: '草案',
  release: '發布',
  services_name: '服務名稱',
  beta_backends: '測試版後端',
  Description: '描述',
  versionhistory: '版本歷史記錄',
  please_select_config: '請選擇配置',
  please_select_service_name: '請選擇服務名稱',
  portservices: ' 端口服務',
  // please_select_service: "請選擇服務",
  Method: '方法',
  Path: '路徑',
  appgroup: '應用組',
  generate_token: '生成權杖',
  true: '真',
  config_description: '配置說明',
  enable_auto_delete: '啟用自動刪除',
  expose_service_address: '暴露服務位址',
  service_address: '服務位址',
  write_able: '寫入能夠',
  please_select_cluster: '請選擇叢集',
  please_select_namespace: '請選擇命名空間',
  please_select_workspace: '請選擇工作區',
  api_versions: 'API 版本',
  service_infos: '服務資訊',
  writable: '可寫入',
  workload_name: '工作負載名稱',
  namespace_name: '命名空間名稱',
  name_length_range: '名稱支持{range}字符',
  cluster_name: '叢集名稱',
  roll_back: '回滾',
  enable_service_address: '啟用服務位址',
  enable_autodelete: '啟用自動刪除',
  workload_type: '工作負載類型',
  auth_token: '身份驗證權杖',
  // cluster: "叢集",
  datacenter: '資料中心',
  // namespace: "命名空間",
  // log_out: "退出登入",
  // no_data: '沒有資料',
  services_address: '服務地址',
  operator: '操作者',
  */
  pwd_rule_prompt_and_desc: '密碼規則提示和說明',
  return_to_log_in: '返回登入',
  enter_email_to_reset_pwd: '輸入電子郵件以重置密碼',
  reset_pwd: '重置密碼',
  forget_pwd: '忘記密碼',
  back_to_login: '已經有帳戶了嗎？ 登入',
  email_address: '電子郵寄地址',
  or_third_party: '或',
  sign_up_text: '注册帳戶',
  u_n_or_p_w_d_error: '使用者名稱或密碼不正確。',
  login_app_name: 'WISE-IoTSuite/MP',
  log_in_sub: '登入到 {name}',
  registered: '註 冊',
  registered_title: '註 冊',
  registered_success: '註冊成功！',
  sign_in: '登入',
  forgot_pwd: '忘記密碼',
  retrieve_password: '檢索密碼',
  retrieve_password_sub: '輸入您的電子郵件位址。稍後將寄送驗證碼。',
  r_to_login: '返回登入頁面',
  p_i_username_e: '請輸入使用者名稱（電子郵件）',
  send_pwd_email: '寄送密碼重置電子郵件',
  send_pwd_email_sub: '如果您忘記了密碼,您可以使用此工具重置密碼。送出後,您將收到一封電子郵件驗證碼,並包含完成該過程的連結。',
  sign_in_sub: '登入到開發人員網路',
  skip: '跳過',
  go_to_change_pwd: '轉到更改密碼',
  system_notification: '系統通知',
  password: '密碼',
  p_i_pwd: '請輸入您的密碼',
  p_i_username: '請輸入您的使用者名稱',
  not_receive_email: '收不到電子郵件',
  draft: '草案',
  release: '發布',
  services_name: '服務名稱',
  beta_backends: '測試版後端',
  Description: '描述',
  versionhistory: '版本歷史記錄',

  portservices: ' 連接埠服務',

  Method: '方法',
  Path: '路徑',
  appgroup: '應用程式群組',
  generate_token: '產生權杖',
  true: '真',
  config_description: '配置說明',
  enable_auto_delete: '啟用自動刪除',
  expose_service_address: '暴露服務位址',
  service_address: '服務位址',
  write_able: '可寫入',

  api_versions: 'API 版本',
  service_infos: '服務資訊',
  writable: '可寫入',
  workload_name: '工作負載名稱',
  namespace_name: '命名空間名稱',
  name_length_range: '名稱支援{range}字符',
  cluster_name: '叢集名稱',
  roll_back: '回滾',
  enable_service_address: '啟用服務位址',
  enable_autodelete: '啟用自動刪除',
  workload_type: '工作負載類型',
  auth_token: '身份驗證權杖',
  // cluster: "叢集",
  datacenter: '資料中心',
  // namespace: "命名空間",
  // log_out: "退出登入",
  // no_data: '沒有資料',
  services_address: '服務地址',
  operator: '操作者',
  // phone: '手機',

  // Top Navbar

  // a
  add_user: '添加使用者',

  // b
  billing_portal: '計費中心',

  // c
  top_console: '主控臺',
  // cancel: "取消",
  // confirm: "確定",
  // contact_technical_support: "聯絡技術支援",

  // h
  hi: '您好，',

  // l
  log_out: '登出',
  log_in: '登入',

  // m
  management_portal: '管理中心',

  // p
  // please_input: '請輸入{type}名稱',

  // s
  // services: "服務",
  // support_message: "如果您遇到問題需要技術支援，請寄送電子郵件至",
  // subscription_name: '訂閱號名稱',
  service_portal: '服務中心',

  // t
  themes: '主題',
  // tickets: "工作訂單",
  ticket_portal: '工作訂單中心',

  // u
  units: '單位',
  // user_center: "使用者中心",

  // desc
  mp_desc:
    '管理中心是 EnSaaS K8s Service 的主控臺。EnSaaS K8s Service 基於 Kubernetes 為使用者提供了開箱即用的微服務框架、企業級的容器管理平臺、多層級的租戶工作空間以及一致性的基礎設施封裝，為應用程式提供了全生命週期管理。',
  sso_desc:
    '使用者中心是 WISE-PaaS 為使用者提供的一套安全、便捷、開放的統一身份認證服務，包括使用者身份管理、企業帳號管理、客戶端管理等功能，支援單一簽入，以及靈活的應用整合方式。',
  service_desc:
    '服務中心是 PostgreSQL、MongoDB、InfluxDB 等多元資料庫、以及RabbitMQ 消息中介軟體、AIFS 等所有託管服務實例的控制台。服務中心提供了資料庫存取以及設備接入平臺的金鑰建立、更新、刪除等全生命週期管理功能以及便捷的操作介面。',
  bill_desc: '計費中心即費用中心，使用者可以即時查看訂單狀態、交易明細、服務價格與會員折扣，以及月帳單等資訊。',
  ticket_desc: '工作訂單中心為平臺使用者線上解決各種問題。所有訂閱號使用者均可以透過此系統建立問題工作訂單，技術支援工程師將根據問題類別與情況逐一處理。',
  container: 'Container',

  // =======================           Buy Portal           =======================
  // management: "管理中心",
  // console: "工作臺",
  // lang: "語言",
  // catalog: "應用商店",
  // billing: "費用",
  // tickets: "工作訂單",
  // order: "訂單",
  document: 'Document',
  blue: 'blue',
  sign_out: '登出',
  available_day: '購買時長',
  // user_center: "使用者中心",
  next: '下一步',
  // confirm: "確定",
  // cancel: '取消',
  previous: '上一步',
  // contact_technical_support: "聯絡我們",
  // support_message: "如果您遇到技術支援問題，請寄送電子郵件至",
  trouble_message: '如果您想排除故障，請寄送電子郵件至',

  // =======================           EnSaaS Service Mesh Portal           =======================

  delete_batch_backend_info: '您確定要刪除已選中的離線後端實例嗎？',
  delete_all_offline_backend_info: '是否要删除该服务的所有离线后端服务实例？',
  agent_update: 'Agent Update',
  agent_update_list: 'List all the information of Config Mgmt. Agents. There is only one agent in each cluster. Users could select the agent to update.',
  container_update: 'Container更新',
  reg_release: '發布',
  service_image_name: '服務鏡像名稱',
  sidecar_updatable: 'Sidecar是否可升級',
  service_image: '服務鏡像',
  images: '鏡像',
  init_images: '初始化鏡像',
  update_sidecar: '更新Sidecar',
  delete_all_backend_info: '確定刪除選中的後端實例嗎？',
  beta: '灰度發布',
  tag_name_exist: '標簽名已存在',
  unbindabled: '解綁',
  bindabled: '綁定',
  config_edit: '更新配置',
  import_config: '導入配置',
  config_management: '配置管理',
  // config: "配置",
  configs: '配置',
  config_list: '配置可儲存各應用內部所需的環境變量資訊，分為公有配置和私有配置，',
  public_config_desc: '所有應用組的公有配置。',
  private_config_desc: '私有配置屬於某壹個應用組，該應用組內的服務都可以訪問應用組內的私有配置。',
  // empty: "空",
  // version: "版本:",

  // 左側選單
  groups: '組',
  app_groups: '應用組',
  app_group_list: '共享某些配置或者功能類似的壹組應用的合集被稱為壹個應用組。',
  version_history: '版本歷史記錄',
  version_history_list: '配置資訊的歷史版本管理，支持回滾到最新版本之前的某壹個歷史版本；保存歷史版本數量上限為為應用組歷史版本數量上限值。',
  listening_management: '监聽管理',
  listening_management_list: '可以查詢使用sdk監聽配置變化的後端應用；支持以配置和後端為維度的配置監聽查詢。',
  group_management: '應用組管理',
  registry: '註冊表',
  service_management: '服務管理',
  backends: '後端實例',
  backends_list: '後端服務實例（如pod）的狀態顯示以及編輯操作。',
  service_authentication: '服務身份驗證',
  port_service: '連接埠服務',
  port_services_list: '每個服務含有壹個或多個服務端口，端口服務管理顯示每個服務端口所對應的具體子服務資訊。',
  // service: "服務",
  traffic_management: '流量控制',
  user_management: '使用者管理',
  distributed_tracing: '分散式跟蹤',
  // table-list 列表
  // edit: "編輯",
  // delete: "刪除",
  expose: '暴露',
  import: '導入',
  watch: '看',
  view_service_registry_information: '查看服務註冊表資訊',
  view_group_information: '查看應用組',
  // whitelist: '白名單',
  auth_filter: '身份驗證篩檢程式',
  resource_filter: '資源篩選器',
  view_port_services: '查看連接埠服務',
  view_backends: '查看後端',
  app_group: '應用組',
  app_grou: '應用組',
  view_history_information: '查看歷史記錄',
  history_information: '歷史資訊',
  view_token: '更新服務配置',
  token_information: '服務配置資訊',
  // loading: "載入。。。",
  // Services
  service_name: '服務名稱',
  service_registry: '服務註冊',
  // created_time: "建立時間",
  service_instance_id: '服務實例 ID',
  subscription_id: '訂閱識別碼',
  updated_time: '更新時間',
  time_stamp: '時間',
  service_registry_information: '服務註冊表資訊',
  total_pod: '總 pod',
  ready_pod: '就緒 pod',
  pod_names: '窗格名稱',
  // create_time: "建立時間",
  // App Groups
  app_group_name: '應用組名稱',
  app_group_id: '應用組 ID',
  // description: "描述",
  salt: '鹽',
  // quota: "配額",
  // name: "名字",
  config_quantity: '配置數量',
  backend_quantity: '後端數量',
  enable_tracing: '啟用跟蹤',
  config_name: '配置名稱',
  format: '格式',
  // tag_name: '標籤名稱',
  // type: "類型",
  is_beta_release: '是測試版',
  release_status: '發佈狀態',
  public_bindable: '公共綁定',
  beta_release: '測試版',
  stop_beta: '停止測試版',
  //port services
  portServiceName: '埠服務名稱',
  internalAddress: '內部位址',
  externalAddress: '外部位址',
  svcAddress: 'Svc 位址',
  // port: "港口",
  targetPort: '目標埠',
  please_select_port_service: '請選擇連接埠服務',
  // please_select_service: "請選擇服務",
  please_select_app_group: '請選擇應用組',
  // rules: "規則",
  skip_rules: '跳過規則',
  skip_rule: '跳過規則',
  format_is_not_valid: '[格式] 無效',
  // name_validate_error_msg: "只有 a-z, 0-9 。和 - 允許",
  // Resource Permission Management
  // resource_permissions_sub: "建立、分配和管理使用者資源權限和角色",
  // resource_permissions: "使用者權限",
  // highest_role: "最高角色",
  // last_login: "上次登入",
  // last_name: "姓氏",
  // status: "地位",
  group_status: '組狀態',
  select_app_group: '選擇應用組',
  // user_info: "使用者資訊",
  // user_info_sub: "使用者的基本資訊和權限",
  // username: "使用者",
  // first_name: "名字",
  // alternative_email: "替代電子郵件",
  // contact_phone: "聯繫電話",
  // industry: "行業",
  // country_region: "國家/地區",
  // company: "公司",
  // address: "位址",
  // city: "城市",
  // user_base_info: "使用者的基本資訊",
  office_phone: '辦公室電話',
  avatar: '化身',
  postal_code: '郵政編碼',
  // resources_mgmt: "資源管理",
  // role: "作用",
  // select_role: "選擇角色",
  // p_s_rc: "請選擇一個或一個或一個",
  // workspace: "工作",
  // data_center: "資料中心",
  // invite: "邀請",
  // delete_role: "是否確實要刪除此角色?",
  // resources_permission_exist: "資源權限已存在",
  admin_resources_permission_exist: '管理員權限已存在,不添加其他權限',
  admin_role_permission_exist: '管理員角色權限已存在,不添加其他權限',
  admin_permission_delete_other: '如果您添加管理員權限,其他權限將被刪除',
  admin_role_delete_other: '如果您添加管理員角色,其他權限將被刪除',
  role_not_insert: '角色未插入',
  // delete_roles: "是否確實要刪除這些角色?",
  // success_save: "已成功保存",
  success_add: '已成功添加',
  role_name: '角色名稱',
  // delete_user: "是否確實要刪除此使用者?",
  // not_login: "尚未登入",
  target_port: '目標埠',
  svc_address: 'SVC 位址',
  // internal_address: "內部位址",
  // external_address: "外部位址",
  delete_service_address: '您確定要從公共服務地址中刪除此服務地址嗎？',
  // save: "儲存",
  description_config: '描述',
  white_list: '白名單',
  add_rules: '添加規則',
  add_skip_rules: '添加跳過規則',
  add_skip_rules_all: '添加跳過規則全部',
  add_env_var: '添加環境變數',
  add_arg: '添加參數',
  group_basic_infomation: '組基本資訊',
  backend_name: '後端名稱',
  listen_start_time: '偵聽開始時間',
  push_config_time: '推送配置時間',
  is_successful: '成功',
  dimension_config: '配置',
  //Query Dimension:
  dimension_ip: '後臺',
  dimension: '維度',
  please_select_dimension: '請選擇尺寸',
  enable_white_list: '啟用白名單',
  add_white_list: '添加白名單',
  rate_limit: '費率限制',
  circuit_breaker: '斷路器',
  port_service_name: '連接埠服務名稱',
  method: '方法',
  // path: "路徑",
  period: '時期',
  rate_limit_value: '流量限制值',
  enable_rate_limit: '啟用流量限制',
  invite_user: '邀請使用者',
  add_rate_limit: '添加流量限制',
  port_services_name: '連接埠服務名稱',
  // protocol: '通訊協定',
  api_version: 'API 版本',
  load_balancing: '負載平衡',
  max_connections: '最大連接',
  max_pending_requests: '最大待定請求',
  max_requests: '最大請求數',
  max_retries: '最大重試次數',
  resource_role_API: '資源角色 API',
  group_basic_information: '組基本資訊',
  history_version_quantity: '歷史記錄版本數量',
  config_size_kb: '配置大小(KB)',
  // id: "配置 ID",
  rateLimitValue: '速率限制值',
  please_select_port_service_name: '請選擇連接埠服務名稱',
  flowcontrol: '流量控制',
  offline_time: '離線時間',
  auto_delete_time: '自動刪除時間',
  delete_sidecar: '刪除sidecar',
  sidecar: 'Sidecar',
  canary: '金絲雀',
  main_weight: '主重量',
  mainWeight: '主重量',
  canary_weight: '金絲雀重量',
  canaryWeight: '金絲雀重量',
  container_name: '容器名稱',
  containerName: '容器名稱',
  image: '圖像',
  replace_env: '替換環境變數',
  replaceEnv: '替換環境變數',
  replace_args: '替換參數',
  replaceArgs: '替換參數',
  env: '環境變數',
  arg: '參數',
  enable_resource_role: '啟用資源角色',
  enable_authentication: '啟用身份驗證',
  enable_canary: '啟用金絲雀',
  has_sidecar: '有sidecar',
  config_id: '設定識別碼',
  please_select_backend_name: '請選擇後端埠名稱',
  view_service: '查看服務',
  enable_service_auth: '啟用服務身份驗證',
  sso_auth_filter: 'SSO 身份驗證篩檢程式',
  ensaas_role_filter: 'EnSaaS 角色篩選器',
  // disabled: "禁用",
  is_disabled: '已啟用',
  access_token: '訪問權杖',
  config_names: '配置名稱',
  token: '權杖',
  all_user: '所有使用者',
  admin: '管理',
  app_group_owner: '應用程式組擁有者',
  numbers_only: '僅數字',
  // service_infos: "服務資訊",
  // generate_token: "生成權杖",
  // services_name: "服務名稱",
  // Description: "描述",
  // expose_service_address: "公開服務位址",
  // enable_auto_delete: "啟用自動刪除",
  // appgroup: "應用組",
  appgrou: '應用組',
  // config_description: "配置說明",
  // draft: "草案",
  // release: "釋放",
  // please_select_config: "請選擇配置",
  // please_select_service_name: "請選擇服務名稱",
  // roll_back: "回滾",
  // versionhistory: "版本歷史記錄",
  // workload_name: "工作負載名稱",
  // namespace_name: "命名空間名稱",
  // cluster_name: "叢集名稱",
  portservice: ' 端口服務',
  // please_select_service: "請選擇服務",
  backend: '後臺',
  // username_email: "使用者名電子郵件",
  // skip: "跳",
  // namespace: "網路Namespace",
  // cluster: "叢集",
  restart_backends: '重啟後端',
  edit_sidecar: '編輯sidecar',
  restart_backends_tip: '重啟所有後端',
  ephemeral_storage: '臨時存儲',
  requests: '要求',
  limits: '限制',
  config_editing: '編輯中',
  current_config: '當前配置',
  backends_information: '後端實例資訊',
  is_initialized: '是否初始化',
  is_canary: '是否是金絲雀',
  enbal_tracing: '啓用跟蹤',
  ip: 'IP',
  service_location: '服務位置',

  global: '首頁',
  requests_or_limits_one_field_is_required: '要求和限制必填',
  sidecar_injected: 'sidecar是否注入',
  public_config_delete_info: '注意: 此操作將會刪除所有的配置資訊!',
  del_config: '配置',
  config_type: '配置類型',
  tag_description: '標簽描述',
  requests_limits: '要求必須小于等于限制',
  export_config_tip: '確定導出嗎?',
  file_is_invalidate: '內容無效',
  workloads_list: '服務註冊功能，將工作負載註入到sidecar中。',
  license_invalid_after: '授權將於',
  n_days: '天後過期',
  license_invalid_immediately: '授權即將失效',
  please_select_config_type: '請選擇配置類型',
  user_permission: '使用者權限',
  is_inject: 'sidecar是否注入',
  workload: '工作負載',
  workloads: '工作負載',
  role_mgmt: '角色管理',
  global_auditor: '全局審計者',
  token_path_info1: '提示：請按照以下格式將token值填入您的服務部署文件的metadata.annotations中：',
  token_path_info2: 'ensaas.k8s.io/accesstoken: <token value>',
  service_address_desc: '公共服務地址列表：當註入Sidecar選擇暴露服務地址選項時，服務的地址將會在此顯示',
  sidecar_is_inject: 'Sidecar已經註入',
  roll_back_to: '確定回滾到 {item} 嗎?',
  active_backends: '在線後端實例',

  // =======================           Tunnel Server           =======================

  // 客戶管理
  clients_desc: '客戶端可以位於一個叢集，容器，虛擬機器，或物理機，用於與映射服務端通訊。建立映射前，您需要先有至少一個客戶端',
  client: '客戶端',
  clients: '客戶端',
  detail: '詳細資訊',
  // delete_msg: '您確定要刪除此{item} 嗎?',
  please_input_tunnel: '請輸入{type}名稱',
  client_ip: '客戶端 IP',
  deploy_file: '部署檔',
  deploy_guide: '部署指南',
  client_hint: `### **操作提示**
  當您添加完客戶端，只是進行了客戶端資訊的建立，您還需要部署客戶端實體。請點擊客戶端右側操作 -> 詳情，查看客戶端詳細資訊，並根據詳細資訊中的教學，進行客戶端的部署`,
  deploy_doc: `### **使用 Deployment 部署**
  1. 點擊部署檔左側的展開按鈕，可以查看部署檔。
  2. 點擊右側的下載按鈕，可以下載部署檔。下載的檔案名稱預設為：<客戶端名稱>.yml
  3. 進入步驟 2 中下載部署檔目錄，執行以下命令，即完成客戶端的部署。注意更改為您的部署檔名稱和命名空間名稱

  \`$ kubectl apply -f <部署檔名稱>.yml -n <命名空間名稱>\`
  `,
  import_doc1: `根據您的環境，下載獲取 token 的批次檔。目前支援 `,
  import_doc2: `。 `,
  import_doc3: `2. windows 下載的檔儲存為 \\<檔名\\>.bat，linux 下載的檔案保存為 \\<檔名\\>.sh
  3. 執行步驟 2 中的腳本，即可獲取到 token 和 server。`,
  import_doc4: '4. 將 ---- 中間部分的內容拷貝到下面的輸入框中（包含 token 和 host 資訊），頁面會自動識別出 token 和 server 填入映射資訊對應的輸入框中。',

  // URL 映射器
  tunnels: '內聯網映射',
  tunnels_desc: '映射可以用於內聯網穿透，外網可以通過映射提供的功能變數名稱，隨時隨地連上內聯網搭建的服務',
  a_type_must_be_selected: '必須選擇{type}',
  mapping_type: '映射類型',
  mapping_info: '映射資訊',
  port_err: '僅接受數位 (0-65535)',
  ip_err: '請輸入有效的 IP',
  hostname_err: '僅允許 0-9 a-z A-Z -',
  hostname_err_internal: '僅允許 0-9 a-z A-Z . 和 -',
  tunnel: ' 內聯網映射',
  type_card: '{type}：',
  external_server_card: '{access_address}：',
  cluster_info: '叢集資訊',
  cluster_token: '叢集權杖',
  access_address: '連接位址',
  internal_server: '內部伺服器',
  internal_server_card: '{internal_server}：{internal_addr}',
  cluster_host: '叢集主機',
  //   web_kubectl:'線上 Kubectl',
  copy: '複製',
  download_tunnel: '下載',
  certificate: '憑證',
  key_tunnel: '金鑰',
  root_certification: '根證書',
  diagnosis: '診斷',
  diagnosis_info: `**{name}**

  診斷網域名稱：: {domain}
  轉寄伺服器 IP: {forward_server_ip}
  映射: {dns_ip}
  區域網路伺服器：{internal_server_address}
  本機內網 IP: {internal_server_ip}
  代理 IP：{agent_ip}
  {status}`,
  view_help: '查看説明',
  get_token: '獲取權杖',
  code1000: '網域名稱已啟動內網穿透功能，並與轉發伺服器 IP 指向一致，連接轉發伺服器成功',
  code1001: '內網映射的外部域名解析錯誤，功能變數名稱沒有啟動內網透傳功能',
  code1002: '內網映射的客戶端離線',
  code1003: '內網映射的伺服器和代理之間建立連接失敗',
  code1004: '區域網伺服器連接失敗',
  // ingress: 'Ingress',
  // batch_assign: '批次映射',

  // Security Settings
  security_settings: '安全性設定',
  // whitelist: '白名單',
  client_whitelists: '客戶端白名單',
  type_whitelists: '{type}白名單',
  // remove: '移除',
  move_up: '上移',
  move_down: '下移',
  ip_address: 'IP 位址',

  // =======================           Bill Portal           =======================
  //type: '類型',
  //company: '公司',
  //status: '狀態',
  //service: '服務',
  // subscription_name: "訂閱號名稱",
  subscriptionName: '訂閱號名稱',
  orderId: '訂單號',
  subscriptionId: '訂閱號',
  transactionId: '交易號',
  createdAt: '建立時間',
  activedAt: '激活时间',
  orderSource: '訂單來源',
  serviceName: '服務名稱',
  serviceCategory: '服務分類',
  plan: '產品規格',
  partNumber: '料號',
  isPaidAccount: '付費帳戶',
  time: '起止時間',
  // pn: '料號',
  identity: '您的身份是',
  here_is: '這是您的總會員價',
  totalProratedPrice: '總價',
  totalListingProratedPrice: '總牌價比例價',
  totalDiscountPrice: '總折扣價',
  currency_unit: '貨幣單位',
  orderStatus: '訂單狀態',
  activated_at: '開通時間',
  ended_at: '到期時間',
  actions: '操作',
  view_details: '查看詳情',
  all_reset: '壹鍵清空',
  totalListingPrice: '總牌價',
  totalMemberPrice: '總會員價',
  total_Prorated_Price: '總比例價',
  deduction: '扣款類型',
  notice_tip: '选選擇關閉後，將默認您已閱讀該公告並且下次不會再顯示，請知悉',
  version_title: 'Change of Payment Terms Notice (EnSaaS)',
  crmId: '企業號',
  // dataCenter: '站點',
  wiseType: '會員身份',
  prepaidServiceCharges: '預付費原價',
  prepaidMemberDiscounts: '預付費折扣',
  postpaidUsageCharges: '按量後付費原價',
  postpaidMemberDiscounts: '按量後付費折扣',
  totalCharges: '應付總額',
  total: '總應付額',
  totalPostpaidMemberDiscounts: '總按量後付費折扣',
  totalPostpaidUsageCharges: '總按量後付費原價',
  totalPrepaidMemberDiscounts: '總預付費折扣',
  totalPrepaidServiceCharges: '總預付費原價',
  bill_tip: '當月最後消費總金額將在次月初產生，在次月4日10點後可查看和匯出，請您屆時留意。',
  Bill: '賬單',
  Order: '訂單',
  bill_cycle: '賬單月份',
  time_period: '時間',
  discount_rate: '折扣率',
  export_content: '導出內容：',
  current_list: '當前查詢條件下的列表',
  current_unit: '當前的貨幣單位：',
  export_bill: '導出賬單列表(CSV)',
  export_order: '導出訂單列表(CSV)',
  crmIdName: '企業號名稱',
  exchangeRateDiscount: '匯率',
  serviceCharges: '原價',
  memberDiscounts: '折扣',
  charges: '按量總額',
  payg_details: '按量詳情',
  // =======================           Catalog Portal           =======================

  // catalog: '目錄',
  // loading: '載入中⋯⋯',
  //not_receive_email: '沒有收到註冊郵件嗎？ ',
  //sign_in_sub: '登入用WISE PaaS EnSaaS SSO賬號',
  //role: '角色',
  //user_info: '使用者資訊',
  //username: '使用者名稱',
  // action: '操作',
  // add: "添加",
  add_catalog: '添加目錄',
  add_project: '添加項目',
  // add_user: "添加使用者",
  admin_theme_name: 'admin 賬號管理',
  admin_theme_subname: '賬號管理系統管理員用詞功能模塊管理賬號，如建立、更新、讀取、刪除admin賬號等',
  admin_account: 'Admin 賬戶',
  apps_info: 'Apps 詳情',
  apps_info_content: '使用者可以看到添加的Apps地址下，所包含的所有App，並進行查看與部屬',
  app_version: 'App 版本',

  // b

  back_to_list: '返回列表',
  basic_info: '基礎資訊',

  // c
  catalog_info: '目錄詳情',
  catalog_number: 'catalog 數量',
  create_project: '建立項目',
  create_admin: '建立 admin',
  charts: 'Charts',
  chart_version: 'Chart 版本',
  create_retry: '建立SSO賬號失敗，請重試！',
  create_success: '建立SSO賬號成功，點擊確認進入EnSaaS Portal或登入電子信箱。',
  confirm_login: '您還沒有登入，確定現在要登入嗎？',
  condition_acount_type: '即日起，開放企業帳號管理機制申請通路。會員類型為VIP及以上可以申請企業帳號。',
  condition_personal_info: '完整填寫企業及個人資訊，並保證資訊真實有效。',

  // d
  deploy_App: '部署應用',
  deploy_App_suc: '部署應用成功！',
  developer: '開發: ',

  // e
  edit_catalog: '編輯目錄',
  edit_project: '編輯項目',
  empty_description: '沒有資料',
  external_host: '外部主機',
  edit_by_form: '編輯表單',
  edit_by_yaml: '編輯 YAML',
  // events: "事件",
  events_content: '使用者可以看到相關操作記錄',
  eam_mechanism: '企業帳號管理機制',
  eam_mechanism_launch: '企業帳號管理機制重磅推出',
  eam_des: '企業帳號管理機制，系統性的支持雲服務代銷，極大的協助研華WISE-PaaS的分銷夥伴以及系統集成商管理終端使用者，以建立完整的平臺生態系。',
  'eam agreement': '企業帳號管理協定',
  eam_conditions: '企業帳號申請條件',
  eam_account_pwd:
    '您的企業帳號開通成功後，您應妥善保管您的帳號和密碼，並正確、安全地使用。帳戶因您主動洩露或因您遭受他人攻擊、詐騙等行為導致的損失及後果，您應自行負責，雲平臺並不承擔責任。',
  eam_administrator:
    '您應將管理子訂閱號的網絡及雲平臺上各類應用和服務的人員實名開通為子訂閱號管理員，如以上人員發生變動，您應自行將變動後的資訊線上進行更新。因您提供的人員資訊不真實、不準確、不完整，以及因以上人員的行為或不作為，或您未及時線上更新人員變動而產生的任何後果，均由您自行承擔。',
  eam_deploy: '雲平臺專屬空間之上部署的應用由個人自行負責。此外，自行陞級應用可能會造成當機等不良影響，個人應自行承擔風險並謹慎操作負責。',
  eam_follow_agreement:
    '您理解並同意，您及您的終端使用者需遵循本協定《WISE-PaaS工業物聯網雲平臺服務協定》，因未能遵守必要設定、使用支持平臺、遵循可接受的使用原則，或對服務的使用管道不符合服務之特性和功能（例如，試圖執行不支持的工作），或不符合雲平臺公佈之指導方針等所產生的損害賠償，雲平臺均不負責，您應自行承擔所有一切協定下既有及衍生之義務及責任。',
  eam_platform_doc:
    '雲平臺提供的相關服務的功能以{website}公佈的使用者指南為准，亦可參攷雲平臺技術白皮書《WISE-PaaS工業物聯網雲平臺架構與服務》。雲平臺有權適時更新服務的功能及相關文件，請登入{website}查閱相關文件的最新版本。',
  eam_answered: '申請將在3個工作日內遞交並得到答复。',
  ea_apply: '企業帳號申請單',
  ea_VIP: '只有VIP及以上會員才能申請企業帳戶',

  // f
  feature_setting: 'Feature Setting',
  free_trial_product: '雲產品免費試用',
  free_trial_desc: '免費體驗超快速，多場景，易於操作和維護的IoT雲產品。',

  // g
  group_theme_name: '群組',
  group_theme_subname: '群組是一個組織您的項目、資源管理訪問權限以及在您團隊内部共享資源等的邏輯單元，可以作爲您團隊工作的獨立工作空間',
  group_list: '群組列表',
  group_owner: 'Group 權限',
  go_now: '現在前往',

  // h
  histories: '歷史',

  // i
  IApp_title: 'I.App',
  IApp_s_p: 'I.App 入門包',
  IApp_subtitle: '使用者可以看到有權限的應用，並快速部署應用',
  internal_host: '内部主機',
  invite_member: '邀請成員',
  info: '詳情',

  // j

  // k
  key_management: 'Key 管理',

  // l
  // last: "上次登入時間：",
  last_login_time: '上次登入時間',
  last_update_time: '上次更新時間',
  limit: '限制',
  load: '載入中',
  load_fail: '載入失敗',
  loading_app: '加載 App 列表...',
  loading_catalog: '加載目錄列表...',
  loading_group: '加載群組列表...',
  loading_plugin: '加載插件列表...',
  loading_project: '加載項目列表...',
  loading_records: '加載訂閲記錄...',
  logging: '日志',
  login_success: '登入成功',
  login: '登入',
  learn_more: '瞭解更多',

  // m
  managed: '管理',
  marketplace: '市場',
  marketplace_setting: '市場設置',
  marketplace_setting_content: 'admin賬戶可以設置marketplace catalog, 整個系統的使用者均可以部署',
  more: '更多',
  member_theme_name: '成員管理',
  member_theme_subname: '列舉出該Group的Group Owner',
  my: '我的',
  my_content: '使用者可以看到的已經訂閲的Catalog',
  my_subscription: '我的訂閲',
  my_subscriptions: '我的訂閲',
  m_s_r: '按月訂閱需付',

  // n
  // notification: '通知',
  // no_data: "無資料",
  notification_theme_name: '公告',
  notification_theme_subname: '可查看最新全部公告資訊',
  no_email: '抱歉，沒有找到該電子信箱的登入中心，請您自行登入電子信箱查看密碼。',
  no_show: '下次不再顯示。',
  new_product: '新品發佈',

  // o
  overview: '首頁',
  official_website: '雲平台官網',

  // p
  project: '項目',
  projects: '項目',
  project_theme_subname: '每個租戶可以創造多個項目，分配給不同的成員管理',
  pipeline: 'Pipeline',
  pipeline_number: 'pipeline 數量',
  private: 'Private',
  private_groups: '私有群組',
  // products: '服務目錄',
  project_number: '項目數量',
  // property: '屬性',
  purchase_options: '價格詳情',
  public_catalog: '公共目錄',
  position_tips: '根據您當前的位置，推薦您查看適用於您所在位置的內容。',
  public_catalog_them_name: 'SRP Application',
  public_catalog_them_subname: '使用者可以看到有權限的應用，並快速部署應用',
  purple: '紫色',
  // 'project_catalog_info_sub_title: 'Project catalog info subTitle',
  // 'project_catalog_info_title: 'Project catalog info title',
  product_release: '產品發佈',
  project_owner: 'Project 權限',
  public_setting: '公共設置',
  pricing_details: '定價詳情',
  public_setting_content: 'admin賬戶可以設置public catalog, 整個系統的使用者均可以部署',

  // q
  quick_start: '快速開始',
  quick_use: '六步驟快速入門 WISE-PaaS/IoTSuite。',

  // r
  // remember_me: "記住我",
  records: '記錄',
  // refresh: "更新",
  resume: '恢復',
  rollback: '回退',
  release_note: '發行說明',
  resale_services: 'WISE-PaaS/EnSaaS 企業帳號機制系統性的支持雲服務代銷。',

  // s
  // search: "搜 索",
  select_date: '選擇日期',
  logOut: '登出',
  started: '已啓用',
  subscribed: '訂閲',
  redeem: '兌換',
  subscription_records: '訂閲記錄',
  subscription_records_content: '使用者可以看到歷史訂閲記錄',
  subTitle: 'subTitle',
  sure_to_delete: '確定刪除？',
  system_setting: '系統設置',
  service_category: '服務類別',
  service_provider: '服務供應商',
  s_a_s_c: '服務架構和產業應用',
  service_details: '服務詳情',
  CST: 'WISE-PaaS 雲服務試用申請表',
  selectService: '請選擇您要試用的服務',
  saleskit_desc: '一站式工業物聯網應用開發套件和雲原生平臺。',

  // t
  tenant: '租戶: ',
  theme: '主題',
  thirdparty_setting: '第三方設置',
  title: '標題',
  tip: '溫馨提示',
  // u
  unstarted: '未啓用',
  update_app: '更新App',
  userCenter: '使用者中心',
  update_app_suc: '更新App成功！',
  URL_Address: 'URL地址',
  // user: "使用者",
  up: '起',
  user_name: '使用者名稱',

  // v
  // view: "查看",
  version_info: '版本資訊',
  view_email: '查看電子信箱',

  // w

  // x

  // y
  you_go_to_now: '您現在將前往: ',
  // z

  //试用申请页面
  Developer: '開發者',
  'IT operation and maintenance': 'IT運維',
  Student: '學生',
  'Business decision-maker': '商務決策者',
  'Technology decision-maker': '技術決策者',
  Architect: '架構師',
  Other: '其它',
  'Subscription Id': '訂閱號',
  CRMID: 'CRMID',
  'User Info': '使用者資訊',
  Company: '公司',
  Email: '電子信箱',
  'Contact Phone': '聯繫電話',
  Profession: '職業',
  'Trial Service': '試用服務',
  'Service Category': '服務類別',
  'Service Name': '服務名稱',
  'Service Plan': '服務Plan',
  'Apply Questionnaire': '申請問卷',
  format_err: '格式不正確，請重試。',
  i_agree: '我已閱讀並同意',
  agreement: '雲服務試用協議',
  'First Name': '姓氏',
  'Last Name': '名字',
  'Member Type': '會員類型',
  // console desc

  // desc
  // mp_desc:
  //     "管理中心是 EnSaaS K8s Service 的主控臺。EnSaaS K8s Service 基於 Kubernetes 為使用者提供了開箱即用的微服務框架、企業級的容器管理平臺、多層級的租戶工作空間以及一致性的基礎設施封裝，為應用程式提供了全生命週期管理。",
  // sso_desc:
  //     "使用者中心是 WISE-PaaS 為使用者提供的一套安全、便捷、開放的統一身份認證服務，包括使用者身份管理、企業帳號管理、客戶端管理等功能，支援單一簽入，以及靈活的應用整合方式。",
  // service_desc:
  //     "服務中心是 PostgreSQL、MongoDB、InfluxDB 等多元資料庫、以及RabbitMQ 消息中介軟體、AIFS 等所有託管服務實例的控制台。服務中心提供了資料庫存取以及設備接入平臺的金鑰建立、更新、刪除等全生命週期管理功能以及便捷的操作介面。",
  // bill_desc:
  //     "計費中心即費用中心，使用者可以即時查看訂單狀態、交易明細、服務價格與會員折扣，以及月帳單等資訊。",
  // ticket_desc:
  //     "工作訂單中心為平臺使用者線上解決各種問題。所有訂閱號使用者均可以透過此系統建立問題工作訂單，技術支援工程師將根據問題類別與情況逐一處理。",

  // =======================          Minisite Portal          =======================

  // 各模块关键词
  announcement: '產品公告',
  product_guides: '使用指南',
  product_brief: '產品簡報',
  report_bug: '聯繫我們',
  faq: '常見問題',
  technology_blog: '技術白皮書',
  troubleshoot: '故障排查',
  admin_console: '管理控制臺',
  product_title: 'EnSaaS Minisite',
  technical_documentation: '技術文檔',
  market_resources: '營銷資源',
  summit: '物聯網峰會',
  resource_center: '資源中心',
  resource_center_desc: '在研華資源中心，您可獲取到工業物聯網新聞及最新技術信息',
  app_name_minisite: '產品名稱',
  please_select_role: '請選擇角色',
  select_product: '請選擇',
  please_select_appname: '請選擇產品名稱',
  confirm_to_delete_role: '您確定要刪除此角色嗎？',
  add_role_warn: '該權限已存在，請勿重復添加！',
  add_admin_role_warn: '已添加最高權限，無須添加其它權限！',

  // MD
  view_detail: '查看詳情',
  view_more: '查看更多',
  more_upper: '更多',
  immediately_view: '立即查看',
  free_trial: '免費試用',
  // total_items: "共 {value} 條",
  input_email: '請輸入電子信箱',
  textArea: '請輸入詳細說明',
  input_require_desc: '請輸入需求概述',
  upload: '上傳圖片',
  upload_label: '單擊或拖拽文件至此區域即可上傳',
  upload_remark: '支持單次或批次上傳(批次最多支持三個文件)',
  business_support: '商務支持',
  technical_support: '開發技術支持及培訓與認證',
  cloud_service: '雲服務故障報修、訂閱與權限相關問題',
  email: '郵 箱',
  submit_success: '成功',
  submit_error: '失敗',
  success_desc: '郵件發送成功!',
  error_desc: '郵件發送失敗!',
  muti_error: '最多只允許上傳三個文件！',
  app_detail: 'App 詳情頁',
  product_publish: '發布',
  please_input_search: '請輸入關鍵字',

  // Contact us
  require_desc: '需求概述',
  bug_desc: '詳細說明',
  submit_problem: '提交問題表單',
  service_need: '您可能需要的服務',
  download: '技術資料下載',
  know: '知道了',
  forward_login: 's 後自動跳轉至登入頁',

  // Guides
  year: '年前',
  month: '月前',
  day: '天前',
  hour: '小時前',
  minute: '分鐘前',
  second: '秒前',

  // =======================           mp Portal           =======================

  // 'management': '管理中心',
  // 'console': '主控台',
  // 'lang': '語言',
  // 'catalog': '應用程式商店',
  '.and-should_not_be_at_the_beginning_or_end': '. 和 - 不能放在首位和末位',
  // a
  active: '啓動',
  active_line: '線上',
  active_time: '建立時間',
  // add: '新增',
  // address: '地址',
  after_restart: '重啟後',
  agent_status: '代理狀態',
  //   'all': '全部',
  // alternative_email: '備用信箱',
  and_bath_assign: '以及配額匯出',
  application: '應用程式',
  application_management: '應用管理',
  applications: '應用程式',
  applications_desc: '提供壹個應用層級的視角，以應用級別查看部署狀態與變化，同時可對應用進行升級、重新部署、啟停與管理。',
  are_you_sure_to_map_the_key_to_quota: '確定將這/這些{key}映射至配額 ',
  'are_you_sure_to_unassign the quota_quotaName_in_namesapce_namespaceName': '確定要取消命名空間{namespaceName}綁定的配額{quotaName}？',
  are_yuo_sure_to_delete_follow_users_permission: '確定刪除以下用戶許可權嗎？',
  assign_quota: '綁定配額',
  assign_quota_msg: '{key}{keyName}已綁定配額{quotaInit}，確定重新綁定到配額{quotaNew}？',
  auto_scale: '是否彈性伸縮',
  auto_scale_desc:
    '是否啟用工作空間的彈性伸縮功能。設置為false，表示為此工作空間綁定固定的工作空間配額；設置為true，表示為此工作空間啟用彈性伸縮功能，該工作空間不再綁定在固定的工作空間配額，而是在最小配額和最大配額之間動態變化。',
  available_quotas: '有效配額',

  // b
  back_to_mp: '返回列表',
  // batch_assign: '批次映射',
  basic_information: '基本資訊',
  batch_add: '批量添加',
  // batch_delete: '批量刪除',
  before_restart: '重啟前',
  broker_host: 'Broker地址',
  // 'billing': '費用',

  // c
  // 'cancel': '取消',
  clear: '清除',
  click_to_sort_by_ascending: '點擊以由小到大排序',
  click_to_sort_by_descending: '點擊以由大到小排序',
  click_to_cancel_sorting: '點擊取消排序',
  cluster_lower: '叢集',
  // 'cluster': '叢集',
  clusters: '叢集',
  clusters_desc: '叢集是計算、儲存和網絡資源的集合，Kubernetes 利用這些資源運行各種基於容器的應用程式',
  cluster_information: '叢集資訊',
  cluster_initialization: '初始化叢集',
  cluster_status: '叢集狀態',
  cluster_agent: '叢集/代理',
  close: '不再顯示',
  close_switch: '關閉',
  // city: '城市',
  // company: '公司',
  compute_resource_quota: '計算資源配額',
  // 'config': '配置文件',
  config_host: '配置主機',
  config_map: 'ConfigMap',
  // confirm: '確定',
  // contact_phone: '聯絡電話',
  // 'contact_technical_support': '聯絡技術支援',
  count: '總數',
  // country_region: '國家/地區',
  cpu: 'CPU',
  // 'create': '建立',
  cpu_nodes: 'CPU節點',
  create_cluster_lower: '建立叢集',
  create_workspace_lower: '建立工作空間',
  create_namespace_lower: '建立命名空間',
  create_workspacequota_lower: '建立工作空間配額',
  create_namespacequota_lower: '建立命名空間配額',
  // 'create_time': '建立時間',
  created_at: '建立時間',
  current_application: '當前應用',
  current_cluster: '當前叢集',
  current_namespace: '當前命名空間',
  current_quota: '當前配額',
  current_workspace: '當前工作空間',

  // d
  data_center: '資料中心',
  datacenter_code: '資料中心',
  dedicate_cluster: '專用叢集',
  'defer_scale-in_for': '縮容觸發時延',
  'defer_scale-in_for_desc': '工作空間滿足縮容標準時，在配置的縮容觸發時延達到後，工作空間開始縮容。單位：分鐘。默認是10分鐘。',
  // 'delete': '刪除',
  // delete_role: '確定要刪除此角色嗎？',
  // delete_roles: '確定要刪除這些角色嗎？',
  // delete_user: '您確定要刪除{name}嗎？ ',
  // deleted: '已刪除',
  deleting: '删除中',
  deployed: '已部署',
  delete_desc: '您確定要刪除嗎?',
  delete_quota_desc: '這個quota現在正在被使用，無法刪除',
  delete_results_are_follows: '刪除結果如下：',
  details: '詳情',
  // disabled: '停用',
  donot_unassign_auota: '{key}不能被取消綁定！',
  download_config_error: '下載 config 失敗!',

  // e
  // 'edit': '編輯',
  edit_cluster_lower: '編輯叢集',
  edit_workspace_lower: '編輯工作空間',
  edit_namespace_lower: '編輯命名空間',
  edit_desc: '您確定要編輯Yaml嗎?',
  edit_yaml: '編輯Yaml',
  // 'empty': '空',
  // error: '失敗',
  external_domain: '外部連結',
  // events: '事件',

  // f
  failed: '失敗',
  // first_name: '名字',
  // forgot_pwd: "忘記密碼",

  // g
  general_workspaces: '一般工作空間',
  gpu_nodes: 'GPU節點',
  guide_step1: '新增工具箱功能，快來體驗吧！',

  // h
  // 'hi': '嗨',
  // highest_role: '最高權限',

  // i
  // industry: '行業',
  infrastructure: '基礎設施',
  // ingress: 'Ingress',
  // invite: '邀請',
  ingress_desc: 'Ingress把來自叢集外部的HTTP和HTTPS流量導入到叢集內的某個APP',
  ingress_overview: 'Ingress 概覽',
  internal_domain: '內部',
  initialization: '初始化',
  install_package: '安裝helm包',
  invite_user_to_cluster_or_workspace: '使用者已經存在，是否要邀請該使用者加入您的叢集或工作空間？',

  // j

  // k

  // l
  last: '登入時間',
  // last_login: '上次登入時間',
  // last_name: '姓氏',
  // license_invalid: "License 已失效，服務已停用",
  // license_invalid_days_14: 'license 已失效，服務還能試用14天',
  // license_invalid_days_front: 'license 已失效，服務還能試用',
  // license_invalid_days_last: '天',
  // license_invalid_immediately: 'License 已失效, 服務即將不可用',
  // loading: '載入中',
  log: '紀錄',
  // 'log_out': '登出',

  // m
  max_quota: '最大配額',
  max_quota_desc: '彈性伸縮的最大工作空間配額，只能選擇16個內置Quota中的一個，且要大於最小配額。',
  memory: '記憶體',
  min_quota: '最小配額',
  min_quota_desc: '彈性伸縮的最小工作空間配額，只能選擇16個內置Quota中的一個。且要小於最大配額。',
  minutes: '分鐘',
  monitor: '監控',
  mp_reactour_step1: '事件功能表新增Pod重啟事件功能。',
  mp_reactour_step2: '監控功能裡加入了Service Usage的監控。',
  mp_reactour_step3: 'Service Portal移到這裡了。',

  // n
  // 'name': '名稱',
  name_input: '名稱',
  namespace_lower: '命名空間',
  // 'namespace': '命名空間',
  namespace_unbind: '命名空間(未綁定)',
  namespace_bind: '命名空間(已綁定)',
  namespaces: '命名空間',
  namespaces_desc: '命名空間是對一組資源和對象的抽象集合，提供隔離作用，常用來將系統内部的對象劃分爲不同的項目組或使用者組',
  namespace_information: '命名空間資訊',
  namespacequota_desc: '命名空間配額',
  namespacequota: '命名空間配額',
  namespaceQuota: '命名空間配額',
  namespacequotas: '命名空間配額',
  'namespace quotas': '命名空間配額',
  namespace_quotas: '命名空間配額',
  'namespace-quotas': '命名空間配額',
  namespace_quotas_desc: '命名空間配額是用來限制使用者資源使用量的一種機制。用於命名工作空間的資源使用量',
  namespace_scale_desc: '資源配額用於限制使用者命名空間的資源消耗',
  namespace_status: '命名空間狀態',
  namespace_usage_t5: '命名空間 (使用量前5名)',
  no_any_been_assigned: '沒有任何映射',
  // 'no_data': '沒有資料',
  node: '節點',
  nodes: '節點',
  nodes_desc: '節點是叢集中的工作主機，是Pod真正運行的主機，可以是物理機，也可以是虛擬機',
  node_usage_t6: '節點（使用量前6名）',
  // not_login: '尚未登入',
  // not_receive_email: "沒有收到註冊郵件嗎？",
  notice_front:
    'KubeEnSaaS 已更新至 4.0.20 版。為進一步豐富用戶的使用場景，這一版我們增加了對GPU資源的運維和管理。更多新特性請參考',
  notice_back: '。',
  no_cluster: '沒有叢集',
  no_workspace: '沒有工作空間',
  no_plan: '沒有方案',
  now_replicas: '當前的實例數',
  new_replicas: '新的實例數',

  // o
  object_count_quota: '其他配額',
  // 'ok': '確認',
  offline: '離線',
  // 'operation': '操作',
  // operator: '操作者',
  // 'order': '訂單',
  operation_time: '操作時間',
  // operation_type: '操作類型',
  // operation_records: '操作記錄',
  _overview: '概覽',

  // p
  // password: '密碼',
  paste: '貼上',
  paste_msg: '您的瀏覽器只允許貼上在終端機中複製的文字。如果要從剪貼簿貼上，請按 Ctrl + Insert 鍵',
  // path: '路徑',
  'pending-install': '等待安裝',
  physical_resource_usage: '物理資源使用量',
  // p_i_pwd: "請輸入密碼",
  // 'please_input_ ': '請輸入',
  please_input_username: '請輸入使用者名稱',
  please_input_keywords: '請輸入關鍵字',
  please_input_description: '請輸入描述',
  pvc_disk: '持久化存儲卷',
  'platform-management': '平臺管理',
  pod: 'Pod',
  pod_restart_alarm: 'Pod 重啟事件',
  pod_restart_alarm_desc: '當pod重啟的時候，會產生一條pod重啟事件，同時記錄該pod重啟前後的日誌。同一個pod重啟多次，僅僅記錄最近一次的重啟日誌。',
  processing: '進行中',
  // p_s_rc: '請選擇國家或地區',

  // q
  // 'quota': '配額',
  quotas: '配額',

  // r
  ready_total: 'Ready/Total',
  // refresh: '重新整理',
  // 'remember_me': '記住我',
  resource_information: '資源資訊',
  // resources_mgmt: '資源管理',
  resource_overview: '資源概覽',
  resource_service: '服務管理',
  resource_permissions: '資源權限',
  resources_permission_mgmt: '資源許可權管理',
  restart_time: '重啟時間',
  // resources_permission_exist: '資源權限已存在',
  // resource_permissions_sub: '建立，分配，管理使用者的資源權限和角色',
  request_limit: '請求/限制',
  // 'role': '角色',
  rootfs: '磁碟',
  router_management: '路由管理',
  // 'rules': '規則',

  // s
  // save: '儲存',
  scale: '擴充/減少容量',
  // search: '搜尋',
  // secret: '金鑰',
  service_name_in_secret: '密鑰中的服務名稱',
  shared_cluster: '共用叢集',
  // 'sign_in': '登入',
  sign_in_to_developer_network: '登入開發者網路',
  // sign_in_sub: "登入到開發者網路",
  // skip: '跳過',
  sorry_no_app_permission: '您尚未訂閱服務',
  sorry_no_resource_permission: '抱歉，您沒有任何資源的權限！',
  sorry_no_subscription_permission: '抱歉，您沒有任何訂閱號的權限！',
  start_switch: '開啟',
  // 'status': '狀態',
  stopped: '停止',
  storage_resource_quota: '存儲資源配額',
  // 'subscription_name': '訂閱號名稱',
  // success_save: '儲存成功',
  // 'support_message': '如果您遇到問題需要技術支援，請寄送電子郵件至',
  suspended: '已暫停',
  svc: '服務名稱',
  system_settings: '系統設置',

  // t
  target_name: '目標名稱',
  // themes: '主題',
  terminal: '終端機',
  terminal_desc: 'Kubectl命令列介面',
  // 'tickets': '工作訂單',
  the_name_has_been_taken: '該名字已被使用',
  // 'this_field_is_required': '此欄位必填',
  total_service: '總數',
  toolbox: '工具箱',
  toolbox_desc: '工具箱提供了config獲取和Web Kubectl操作工具',
  // 'total_items': '共 {value} 條',
  // 'type': '類型',

  // u
  unassign_quota: '取消綁定配額',
  unbind: '取消綁定',
  // 'units': '單位',
  // update_time: '更新時間',
  usage_quota: '使用量/配額',
  // 'user': '使用者',
  users: '使用者',
  // user_base_info: '使用者基本資訊',
  // 'user_center': '使用者中心',
  user_groups: '使用者群組',
  // user_info: '使用者資訊',
  // user_info_sub: '使用者的基本資訊與權限',
  // username: '使用者名稱',
  // username_email: '使用者名稱（電子信箱）',

  // v
  // 'view': '查看',
  Version: '版本',
  view_yaml: '查看yaml',
  view_in_yaml: '查看yaml',
  view_these_binded_key_and_export_them_quotas: '查看{key}配額使用情況、批次綁定配額{quotas}',

  // w
  //   'web_kubectl': 'Web Kubectl',
  what_new: '新功能',
  workloads_app_desc: '屬於應用的工作負載',
  workloads_desc: '使用者在命名空間中部署的應用程式',
  workspace_lower: '工作空間',
  // 'workspace': '工作空間',
  workspace_unbind: '工作空間(未綁定)',
  workspace_bind: '工作空間(已綁定)',
  workspace_create_tip: '只接受a-z 0-9且最多16個字元',
  workspace_create_tip_else: '只接受 a-z 0-9 . - 字元',
  workspace_name: '工作空間名稱',
  workspaces: '工作空間',
  workspaces_desc: '工作空間是一個管理命名空間、資源管理存取權限以及在内部共享資源等的邏輯單元，可以作爲獨立工作空間使用',
  workspace_information: '工作空間資訊',
  workspace_status: '工作空間狀態',
  workspacequotas: '工作空間配額',
  workspacequota_lower: '工作空間配額',
  workspacequota: '工作空間配額',
  workspaceQuota: '工作空間配額',
  'workspace quotas': '工作空間配額',
  workspace_quotas: '工作空間配額',
  'workspace-quotas': '工作空间配額',
  workspace_quotas_desc: '工作空間配額是用來限制使用者資源使用量的一種機制。用於管理工作空間的資源使用量',
  workspace_scale_desc: '資源配額用於限制使用者工作空間的資源消耗',
  workspace_usage_t5: '工作空間（使用量前5名）',
  '--without_quota--': '--不指定配額--',

  // =======================           MP Lite Portal           =======================
  access_url: 'Access URL',
  application_name: '實例名稱',
  Application: '應用程式',
  app_name: '應用程式名稱',
  can_not_update: '沒有可升級的版本',
  classification: '分類',
  cluster_not_found: '叢集不存在。',
  gpu: 'GPU',
  package_name: '服務包名',
  redeploy: '重新部署',
  restart: '重啓',
  service_package: '服務包名稱',
  start: '啓動',
  start_app: '啓動',
  stop_app: '停止',
  sure_restart: '確定要重啓此應用嗎？',
  sure_redeploy: '確定要重新部署此應用嗎？',
  sure_start: '確定要啓動此應用嗎？',
  sure_stop: '確定要停用此應用嗎？',
  sure_update: '確定要升級此應用嗎？',
  unclassified: '未分組',
  update_to_version: '更新至{version}',
  workspace_id: '工作空間ID',
  verify_sub: '為了您的安全，我們需要驗證您的身份。我們已經向電子郵件發送了驗證碼。',
  // Service Portal
  advanced_parameters: '其他參數',
  aggregate: '總量',
  all_subscription: '全部訂閱號',
  array: '陣列',
  authentication_database: '認證用資料庫',
  auto_input: '自動產生',
  back_to: '返回至',
  bindable: '可綁定',
  bind_model: '綁定模式',
  body: '身體',
  boolean: '布林值',
  broker_bindable: '可綁定',
  broker_display_name_tooltip: '顯示在密鑰中的服務名稱。',
  broker_plan_id: '方案ID',
  broker_service_id: '服務ID',
  broker_url: 'Broker網址',
  canceling: '正在取消…',
  cancel_subscribe: '取消訂閲',
  cancel_success: '取消成功！',
  capacity: '容量',
  charge_type: '收費類型',
  select_storage_class: '選擇存儲類',
  cluster_type: '叢集類型',
  content: '内容',
  create_broker_title: '新增服務',
  credentials: '憑證',
  create_DCCS: '建立服務金鑰',
  create_pvc_radio1: '使用存儲類動態建立',
  create_secret: '建立密鑰',
  create_secret_title: '密鑰管理',
  create_secret_subscription: '管理連線至服務時需要的密鑰',
  create_success_sp: '建立成功！',
  creating: '正在建立…',
  creation_time_mp: '建立時間',
  dashboard_url: '儀表板網址',
  database_version: '資料庫版本',
  dataService: '料號資訊',
  db_help_message: '只允許使用a-z、A-Z、0-9、-，-不得在開頭，且上限為63字元。',
  db_help_tooltip: '{name}只允許使用a-z、A-Z、0-9、-，-不得在開頭，且上限為63字元。若不填寫，則綁定時會自動產生一組{name}。',
  db_name: '資料庫名稱',
  dccs_key: '服務金鑰',
  dccs_name: '服務金鑰名稱',
  delete_cluster: '刪除叢集',
  delete_instance_a: '確定要刪除實例嗎？此動作不會影響資料庫。',
  delete_instance_b: '執行此動作會將此實例所使用的資料庫刪除，您確定嗎？',
  delete_instance_c: '確定要刪除實例嗎？',
  delete_service_broker: '具有相同服務名稱和方案的項目將會被一併刪除。確定要刪除嗎？',
  delete_success: '刪除成功！',
  delete_secret: '刪除 {secretName} 後將無法恢復。確定要刪除嗎？',
  deployment_properties: '部署屬性',
  deployment_name: '部署名稱',
  detached: '已分離',
  detach_cluster: '分離叢集',
  detachedClusters: '分離叢集數',
  detachedInstances: '分離實例數',
  disable_success: '停用成功！',
  disable_mp: '停用',
  disabling: '正在停用……',
  edit_DCCS: '編輯',
  edit_instance: '編輯實例',
  update_secret: '更新密鑰',
  please_input_name: '請輸入{type}名稱',
  edit_instance_checkout_msg: '重啟密鑰所在的命名空間下的所有應用程式',
  edit_success: '編輯成功！',
  enable_success: '啓用成功！',
  enabling: '正在啓用……',
  enter_any_value: '此欄位在私有雲環境請輸入任意值。',
  external_hosts: '外部地址',
  existing_storage_class: '已有儲存類',
  form: '表單',
  header: '頁眉',
  host_role: '此欄位的格式為{tag1}host{tag2}:{tag1}port{tag2}，若有多組，每組請以逗號（,）分隔',
  input_regexp_1: '僅允許 [a-zA-Z0-9.-]',
  input_regexp_2: '. 和 - 不允許出現在開頭與結尾',
  input_regexp_3: '僅允許數字',
  input_regexp_4: '僅允許 [0-9a-f-]',
  input_regexp_5: '僅允許 [a-zA-Z0-9:-.,]',
  input_regexp_6: '僅允許 [a-z0-9.-]',
  input_regexp_7: '僅允許 [a-zA-Z0-9._-] 和空格',
  input_regexp_8: '僅允許 [a-zA-Z0-9._-]',
  input_regexp_9: '不允許空格',
  input_regexp_10: '僅允許 [a-zA-Z0-9_-.+]',
  input_regexp_11: '僅允許 [a-zA-Z0-9_-./@:]',
  input_regexp_12: '此名稱為保留名稱，請使用其他名稱。',
  input_regexp_13: '不合法的名稱，請使用其他名稱。',
  input_regexp_14: '僅允許 a-z A-Z 0-9 . 和 - 且必須以小寫字母開頭。',
  instance_id: '服務實例ID',
  instance_list: '實例列表',
  instance_name: '實例名稱',
  instancesQuota: '實例配額',
  integer: '整數',
  internal_hosts: '內部地址',
  key: '鍵',
  key_repeat: '{keyZH}不可重複。',
  loading_app_list: '正在載入應用程式列表……',
  location: '位置',
  max_length: '不得大於{length}字元長度。',
  namespace_not_found: '命名空間不存在。',
  name_repeat: '已存在相同名稱的{name}。',
  monitoring: '監控',
  next_page: '下一頁',
  no_instance: '查無實例',
  no_pn: '查無料號',
  no_cluster_found: '找不到可用的叢集。',
  no_namespace_found: '找不到可用的命名空間。',
  no_storage_class: '暫無儲存類，使用儲存類建立pvc，您需要至少有一個儲存類。',
  no_workspace_found: '找不到可用的工作空間。',
  not_a_valid_UUID: '不是合法的UUID。',
  notice_front_lite:
    'EnSaaS K8s Service Lite 已更新至 4.1.5 版。該版本更新了頁面樣式，同時將訂閲號選框移入頁面内部。從EnSaaS-K8s-Service 4.0.11后，拆分出EnSaaS-K8s-Service Lite，並合并了Service Portal，用於IoTSuite Edge的場景。更多新特性請參考 ',
  overview_create_dedicated: '建立專用叢集',
  overview_create_shared: '建立共享叢集',
  // parameters: '參數',
  persistent_disk_size: '永久磁碟大小',
  persistent_disk_type: '永久磁碟類型',
  persistent_volume: '儲存',
  please_choose: '請選擇',
  please_input_mp: '請輸入',
  please_input_value: '請輸入{value}。',
  plan_sp: '方案',
  plan_name: '方案名稱',
  prev_page: '上一頁',
  provider: '提供者',
  pseudo_id: '虛擬ID',
  pv: '持久卷',
  pv_desc: '持久卷（PV）是對底層共享儲存的一種抽象，將共享儲存定義爲一種資源，它屬於機群級別資源，不屬於任何命名空間。',
  pvc: '持久卷聲明',
  pvc_desc: '持久卷生命（PVC）是使用者對儲存的請求。它類似於pod。Pod消耗節點資源，持久卷聲明會消耗儲存資源。',
  recreate: '重建',
  recreating: '正在重建...',
  recreate_secret: '此操作將會在指定的命名空間中建立名為 {secretName} 的密鑰（Secret），若命名空間中已經存在同名的密鑰，將會被覆蓋。',
  recreate_success: '重建成功！',
  recycle_strategy: '回收策略',
  redeploy_failed: '重新部署失敗！',
  redeploy_success: '重新部署成功！',
  remain: '剩餘數',
  remainInstances: '剩餘實例數',
  rename: '更改名稱',
  rename_instance: '更改名稱',
  rename_instance_overview: '更改名稱',
  rename_success: '更改成功！',
  resource_management: '資源管理',
  restart_all_apps_edit: '編輯完成後重新啟動有關聯的應用程式',
  resume_cluster: 'Resume Cluster',
  running: '運行中',
  runningClusters: '運行叢集數',
  runningInstances: '運行實例數',
  search_placeholder: '輸入後請按ENTER鍵搜尋{name}',
  secrets: '密鑰',
  secret_name: '密鑰名稱',
  secret_management: '密鑰管理',
  series: 'Series',
  service_instance: '服務實例',
  service_instance_list: '服務實例列表',
  service_instance_name: '服務實例名稱',
  service_instance_id_tooltip: '產生一組service instance ID。',
  service_key: '服務金鑰',
  service_list: '服務列表',
  service_list_subscription: '使用者可以管理訂閱中的服務',
  service_list_title: '實例列表',
  service_management_subscription: '管理員可以對服務進行管理',
  service_management_title: '服務管理',
  service_plan_name: '服務方案名稱',
  service_usage: '服務用量',
  'service-usage-service-tooltip':
    'MongoDB、PostgreSQL僅支持Shared方案實例的用量監控，RabbitMQ僅支持standard方案實例的用量監控，EnSaaS-K8s-Service目前僅支援Dedicated Cluster方案實例的用量監控。',
  service_username: '使用者名稱',
  ssl: 'SSL',
  scale_success: 'Scale successful!',
  scale_failed: 'Scale failed!',
  start_success: '啓用成功！',
  start_failed: '啓用失敗！',
  stop_failed: '停用失敗！',
  stop_success: '停用成功！',
  storage: '儲存類',
  storage_class_desc: '儲存類為管理員提供了一種描述儲存的“類”的方法。主要用於動態分配持久卷。',
  storage_statement: '儲存聲明',
  storage_volume: '關聯的儲存卷',
  string: '字串',
  subscription_success: '訂閲成功！',
  subscription_title: '建立實例',
  support: '支援',
  support_content: '如果您遇到技術支援問題，請寄送電子郵件至 ',
  support_title: '聯絡技術支援',
  sure_to_cancel: '確定要取消訂閲嗎？',
  sure_to_disable: '確定要停用嗎？',
  sure_to_enable: '確定要啓用嗎？',
  sure_to_recreate: '確定要重建嗎？',
  this_is_required: '此為必填項目',
  time_since_create: '已建立時長',
  totalActive: '已啓用叢集',
  totalClusters: '叢集總數',
  totalInactive: '非啟用叢集',
  totalInprogress: '待處理叢集',
  total_mp: '總數',
  transaction_id: '交易ID',
  unlimited: '無限制',
  update_failed: '更新失敗！',
  update_success: '更新成功！',
  update_broker_title: '更新服務',
  'user-defined-plan': '使用者自訂方案',
  userId: '使用者 ID',
  // value: '值',
  vhost_name: 'vhost名稱',
  view_resource: '查看資源',
  visit_model: '連線模式',
  vmSize: '虛擬機器大小',
  vmType: '虛擬機器類型',
  workspace_not_found: '工作空間不存在。',
  ':': '：',

  // =======================           sso           =======================
  // a
  account_owners: '帳戶所有者',
  accounts: '成員',
  active_sso: 'Active',
  active_zh: '啟動',
  add_enterprise: '添加企業帳號',
  add_enterprise_user: '添加企業帳號管理員',
  add_to_sub: '添加至訂閱號',
  add_sub: '添加訂閱號',
  add_sub_user: '添加訂閱號使用者',
  adjustment: '調整',
  admin_sso: '管理員',
  all_sub: '所有訂閱號',
  all_enterprise: '所有企業帳號',
  all_normal_sub: '所有正式訂閱號',
  app_id: 'App ID',
  app_role: '應用角色',
  app_permissions: '應用權限',
  available_points: '可用點數',
  available_credit: '可用額度',
  // b
  balance: '餘額',
  billing_sso: 'Billing',
  bind_phone: '綁定手機',
  bind_phone_title: '綁定手機',
  bind_phone_info: '此功能目前僅在中國大陸地區試運行',

  // c
  change_pwd_by_policy: '請按照規則修改密碼',
  client_sso: '客戶端',
  clients_sso: '客戶端',
  client_edit: '編輯客戶端資訊',
  client_id: '客戶端 ID',
  client_name: '客戶端名稱',
  client_role: '客戶端權限',
  client_sub: '注意：頁面操作取決於您在組織中的權限。',
  client_s: '客戶端建立成功！',
  client_s_sub: '請妥善保存您的客戶端ID和密鑰。',
  client_s_notice: '您將只能在這裡看到此金鑰一次！所以一定要立即複製保存。',
  client_normal: '平臺部署應用客戶端',
  client_oauth: 'OAuth客戶端',
  client_trust: '託管服務客戶端',
  client_user: '應用使用者',
  client_user_info: '管理客戶端下的使用者',
  close_sso: '關閉',
  clusterAdmin: '叢集管理員',
  clusterOwner: '叢集所有者',
  common_app: 'Common App',
  complete: '完成',
  cost_center: '支付中心',
  creation: '建立',
  creation_time_sso: '建立時間',
  create_client: '建立客戶端',
  create_client_sub: '請輸入客戶端資訊',
  create_retry_sso: '建立SSO帳號失敗，請重試！',
  create_success_sso: '建立SSO帳號成功，您將收到一封EnSaaS SSO 帳號註冊信，請您按照註冊信中的資訊及時修改密碼。',
  creator: '建立者',
  crmid: 'CRM ID',
  current_hosting_status: '當前託管狀態',
  // d
  datacenterAdmin: '資料中心管理員',
  delete_subscription: '確定要刪除{name}嗎？',
  delete_sub_role: '確定刪除訂閱號{name}的權限嗎?',
  delete_with_name: '確定要刪除{name}嗎？',
  discount_record: '折扣率變更記錄',
  document_sso: '文件',
  document_api: 'API文件',
  // e
  email_s: '電子信箱',
  ensaas: 'EnSaaS',
  enterprise_account: '企業帳號',
  enterprise_account_sub: '企業帳號管理員可以建立企業帳號下的訂閱號並管理訂閱號下的使用者',
  enterprise_export: '企業帳號匯出',
  enterprise_user: '企業帳號使用者',
  enterprise_user_sub: '設置企業帳號管理員',
  enterpriseAdmin: '企業帳號管理員',
  enter_member: '訂閱號個數',
  expenses_record: '可用額度變更記錄',
  // f
  // g
  globalAdmin: '平臺管理員',
  go_creation: '返回建立頁面',
  go_mgmt: '返回管理頁面',
  go_to_change_pwd_sso: '修改密碼',
  // h

  hosting: '託管',
  hosting_deal_subscription:
    '您收到來自訂閱號管理員的 {count} 條託管處理請求，點擊 OK 前往訂閱號頁面處理。或稍後自行前往【訂閱號管理】【操作】【託管】進行處理。',
  hosting_deal_enterprise:
    '您收到來自企業帳號管理員的 {count} 條託管處理請求，點擊 OK 前往訂閱號頁面處理。或稍後自行前往【訂閱號管理】【操作】【託管】進行處理。',
  hosting_deal_both:
    '您收到來自訂閱號管理員的 {subCount} 條託管處理請求和來自企業帳號管理員的 {epCount} 條託管處理請求，點擊 OK 前往訂閱號頁面處理。或稍後自行前往【訂閱號管理】【操作】【託管】進行處理。',
  hosting_state: '託管狀態',
  hosting_record: '託管記錄',
  // i

  identity_record: '身份變更記錄',
  identity_before: '操作前身份',
  identity_after: '操作後身份',
  info_safe: '我們不會洩露您的手機資訊',
  invite_user_sso: '使用者已經存在，是否要邀請該使用者加入您的叢集或工作區？',
  is_paid_account: 'Is Paid',
  is_internal: 'Is Internal',
  // j
  // k
  // l
  last_modify_time: '上次修改時間',
  // m
  mgmt: '管理',
  management_user: '管理使用者',
  management_user_info: '管理所有使用者，包括添加、刪除、啟用和禁用等',
  member_type: '客戶類型',
  m_detail: '明細',
  modify: '修改',
  modify_phone: '修改手機',
  my_profile: '個人資料',
  // n
  name_crmid: '名稱（CRM ID）',
  namespaceDeveloper: '命名空間開發者',
  new_pwd: '新密碼',
  new_pwd_confirm: '確認新密碼',
  no: '否',
  not_remain_again: '不再提示',
  // o
  operating_time: '操作時間',
  operating_points: '操作點數',
  // operation_record: '操作記錄',
  operation_record_sub: '記錄關鍵的刪除、新增、修改等操作',
  // operation_type: '操作類型',
  operation_total_points_before: '操作前總點數',
  ope_target_type: '目標類型',
  ope_target_name: '目標名稱',
  ope_target_identity: '目標身份',
  ope_action: '操作',
  ope_operator_name: '操作者',
  ope_create_time: '操作時間',
  ope_target_id: '目標ID',
  ope_description: '描述',
  // p
  permission: '權限',
  p_i_app_id: '請輸入APP ID',
  p_i_service_name: '請輸入服務名',
  p_i_user_id: '請輸入使用者ID',
  p_i_integer: '請輸入整數',
  p_i_city: '請輸入您的城市',
  p_i_client_name: '請輸入您的客戶端',
  p_i_crmid: '請輸入CRM ID',
  p_i_company: '請輸入公司名稱',
  p_i_sub_company: '請輸入公司名稱',
  p_i_scopes: '請輸入權限集合,例如: admin,user',
  p_i_redirect: '請輸入重定向路徑',
  p_i_quota_point: '請輸入可用額度',
  p_i_sub_name: '請輸入訂閱號',
  p_i_sub_short_name: '請輸入訂閱號名稱',
  p_i_sub_rate: '請設置WISEPoint與所選貨幣的匯率',
  p_i_enterprise_name: '請輸入企業帳號',
  p_i_sub_id: '請輸入訂閱號ID',
  p_i_trust_key: '請輸入託管服務密鑰',
  p_i_valid_url: '請輸入有效網址',
  p_i_verify_code: '請輸入驗證碼',
  // p_i_phone: '請輸入手機號碼',
  p_s_dc: '請選擇資料中心',
  p_s_cluster: '請選擇叢集',
  p_s_ws: '請選擇工作空間',
  p_s_ns: '請選擇命名空間',
  p_s_mt: '請選擇帳戶類型',
  p_s_sub: '請選擇訂閱號',
  p_s_enterprise: '請選擇企業帳號',
  phone: '手機',
  phone_s: '手機',
  phone_number: '手機號碼',
  points_spent: '已消費點數',
  points_credit: '信用點數',
  points_available: '剩餘點數',
  points_available_trail: '剩餘信用點數',
  points_total: '總點數',
  // q
  quota_point: '消費上限',
  // r
  record_OpenHosting: '委託託管',
  record_CloseHosting: '結束託管',
  record_OpenHostingRequest: '請求託管',
  record_CloseHostingRequest: '取消託管請求',
  record_ChangeHostingRequestPass: '請求託管被通過',
  record_ChangeHostingRequestReject: '請求託管被拒絕',
  redirect_url: '重定向路徑',
  // remove: '移除',
  remove_user: '確定要把{name}從訂閱號下移除嗎？',
  remove_users: '確定要移除這些使用者嗎？',
  remove_email: '確定要移除{name}嗎？',
  resources_permission: '資源權限',
  roles: '角色',
  roles_introduction: '角色介紹',
  roles_sub: '使用者角色說明',
  role_ga: 'Global Admin',
  role_ga_des:
    'EnSaaS全球資料中心的管理者，負責全球所有資料中心的管理，有所有資料中心的最高管理權限；可以分配資料中心管理員、叢集管理員及租戶空間角色；有訂閱號管理權限，可以建立訂閱號和分配訂閱號使用者。',
  role_da: 'DataCenter Admin',
  role_da_des:
    '某個資料中心的管理者，負責本資料中心的管理，有本資料中心所有叢集的最高管理權限；可以管理所有叢集的資源，可以分配叢集管理員及租戶空間角色；有訂閱號管理權限，可以建立訂閱號和分配訂閱號使用者。',
  role_ca: 'Cluster Admin',
  role_ca_des:
    '某個Kubernetes叢集的管理者，負責本叢集的管理；有本叢集的所有權限，包括所有工作空間和所有命名空間的管理權限，以及叢集中所有部署的應用的管理權限，擁有本叢集全部Kubernetes資源的管理權限；可以分配租戶空間角色；沒有訂閱號管理權限。',
  role_co: 'Cluster Owner',
  role_co_des:
    '某個獨享規格叢集的所有者，負責本叢集級別租戶空間的管理；有本叢集的存取權限，包括所有工作空間和所有命名空間的管理權限，以及租戶在此叢集中所部署的應用的管理權限，擁有本叢集中部分Kubernetes資源的管理權限；可以分配工作空間和命名空間角色。沒有本叢集的訂閱、升級、降級和退訂等商務功能的操作權限。',
  role_wo: 'Workspace Owner',
  role_wo_des:
    '某個通用規格工作空間的所有者或某個獨享規格叢集中建立的某個工作空間的所有者，負責本工作空間級別租戶空間的管理，有本工作空間的存取權限，有本工作空間下的所有命名空間的管理權限，以及租戶在此工作空間中所部署的應用的管理權限，擁有本工作空間中部分Kubernetes資源的管理和存取權限；可以分配命名空間角色。沒有本工作空間的訂閱、升級、降級和退訂等商務功能的操作權限。',
  role_nd: 'Namespace Developer',
  role_nd_des: '某個命名空間的開發者，有本命名空間的存取權限，包括本命名空間中所部署的應用的管理，擁有本命名空間中部分Kubernetes資源的管理權限。',
  role_s_sa: 'Subscription Admin',
  role_s_sa_sub:
    '某個訂閱號的管理者，EnSaaS  訂閱號與MyAdvantech企業帳號相對應。訂閱號管理員有在EnSaaS雲平臺上訂閱、升級、降級、退訂產品/服務/資源(統稱為雲服務)的權限，訂閱後預設擁有雲服務的管理權限和存取權限；訂閱號管理員有管理雲服務訂單、帳單等商務功能的權限。',
  role_s_su: 'Subscription User',
  role_s_su_sub: '某個訂閱號下的一般使用者，擁有訂閱號所訂閱的雲服務的管理和存取權限，沒有服務訂閱、退訂權限，沒有訂單、帳單等商務功能的管理權限。',
  role_srp_u: 'SrpUser',
  role_srp_u_sub: '某個應用類雲服務的使用者，有應用的存取權限，應用訪問者具體所擁有的應用角色由應用最高權限訪問者分配；SRPUser 沒有EnSaaS 租戶空間的存取權限。',
  role_not_insert_sso: '發現您有訂閱號權限資訊未添加至訂閱還權限清單，需要返回修改嗎？',
  // s
  scopes: '權限集合',
  security_code: '客戶端金鑰',
  send_pwd_phone_success: '成功發送密碼重置簡訊。 頁面將在5秒鐘後跳轉。',
  send_verify_code_again: '{name}秒後重新發送',
  send_pwd_email_sub_sso: '如果您忘記了密碼，可以使用此工具重置密碼。 提交後，您將收到一封包含連結的電子郵件或手機驗證碼，以完成該過程。',
  select_sub: '請選擇訂閱號',
  signOut: '登出',
  srp: 'Srp',
  srpUser: '應用使用者',
  sso_permissions: 'SSO權限',
  success_delete: '刪除成功',
  success_insert: '添加成功',
  subscription_details: '訂閱號詳情',
  subscription_export: '訂閱號匯出',
  subscription_mgmt: '訂閱號管理',
  subscription_user: '訂閱號使用者',
  subscription_id_sso: '訂閱號ID',
  subscription_detail: '管理訂閱號下的使用者',
  subscription_sub: '訂閱號管理，資訊查看',
  subscription_type: '訂閱號類型',
  subscription_id_role: '訂閱號角色',
  subscriptionAdmin: '訂閱號管理員',
  subscriptionUser: '訂閱號一般使用者',
  subscribed_permissions: '訂閱號權限',
  subscribed_permissions_up: '確定提升權限為訂閱號管理員 ？',
  subscribed_permissions_down: '確定降低權限為訂閱號一般使用者 ？',
  sub_basic: '基本資訊',
  sub_role: '權限配置',
  sub_rate_prompt1: '當前折扣率（{name} %off），直到本月底仍然有效。',
  sub_rate_prompt2: '新的折扣率將於下月生效。',
  sub_cost: '費用配置',
  sub_short_name: '訂閱號名稱',
  sub_company: '公司名稱',
  sub_shared_discount: '共用會員折扣',
  sub_allow_billing: '允許訪問費用中心',
  sub_service_trust: '請求服務託管',
  sub_service_trust_info: '若選擇開啟，訂閱號管理員登入時會收到託管授權請求',
  sub_top_cost: '當前可用額度',
  sub_billing_unit: '費用帳單單位',
  sub_billing_unit_info: '設置WISEPoint與所選貨幣的匯率後，訂閱號的帳單則按照這個匯率呈現',
  sub_discount_rate: '折扣率',
  sub_effective_discount: '生效折扣率',
  sub_exchange_rate: '匯率',
  sub_enter_admin: '企業帳號管理員',
  sub_guest_deal_request_choose_no: '不，我自己管理服務。',
  sub_guest_deal_request_choose_yes: '是的，管理員可以託管我的服務並訪問我的資料。',
  sub_guest_deal_request_choose: '您希望向您的企業帳號管理員託管您的服務嗎？',
  sub_guest_deal_request_label: '請求發起人',
  sub_guest_deal_request_for_label: '目標訂閱號',
  sub_guest_deal_request_msg: '您的企業帳號管理員向您發送了一個服務託管請求，請在下面處理。',
  sub_guest_denied_msg: '訂閱號管理員已終止您的託管權限',
  sub_guest_accept_msg: '您的服務託管請求已被接受',
  sub_guest_reject_msg: '您的服務託管請求已被拒絕',
  sub_guest_denied_label: '終結者',
  sub_guest_denied_form_label: '訂閱號',
  sub_guest_hosting_label: '您的服務當前由企業管理員託管',
  sub_guest_unhosted_label: '您的服務未由企業管理員託管',
  sub_guest_configure: '配置託管狀態',
  sub_guest_configure_no: '管理員不能託管我的服務和訪問我的資料',
  sub_guest_configure_yes: '管理員可以託管我的服務並訪問我的資料',
  sub_guest_prompt: '您可以從下面更改託管狀態',
  sub_guest_request_label: '授權者',
  sub_guest_accept_label: '授權者',
  sub_guest_reject_label: '拒絕者',
  sub_guest_request_title: '您可以在下面更改託管設置',
  sub_guest_request_msg: '訂閱號管理員已授予您託管權限',
  sub_hosting: '託管',
  sub_hosting_basic: '基本資訊',
  sub_hosting_req_process: '請求處理',
  sub_hosting_status: '託管狀態',
  sub_hosting_action: '託管動作',
  sub_hosting_unhost: '未託管',
  sub_hosting_hosted: '已託管',
  sub_hosting_hosting: '託管',
  sub_hosting_stop: '終止',
  sub_hosting_await_process: '待處理的請求',
  sub_hosting_none: '無',
  sub_hosting_process_sponsor: '請求發起人',
  sub_hosting_current_identity: '操作人身份',
  sub_hosting_request_initiator_identity: '請求發起人角色',
  sub_hosting_process_status: '請求狀態',
  sub_hosting_pending_request: '待請求',
  sub_hosting_requesting: '請求中',
  sub_hosting_requested: '請求中',
  sub_hosting_denied: '拒絕',
  sub_hosting_request: '訂閱號託管請求',
  sub_hosting_no_permission: '訂閱號有待處理請求，您的身份暫無可處理動作。',
  sub_host_cancel_request_choose_no: '等待訂閱號管理員回復',
  sub_host_cancel_request_choose_yes: '取消請求',
  sub_host_cancel_request_choose: '或者您可以取消請求',
  sub_host_cancel_request_label: '發送至',
  sub_host_cancel_request_msg: '已發送託管 子訂閱號服務的請求，請等待回復',
  sub_host_request_title: '您可以請求子訂閱號託管服務',
  sub_host_request_prompt: '您無權託管子訂閱號的服務',
  sub_record: '訂閱號記錄',
  sub_record_point_consumption: '點數消費',
  sub_record_point_limit_change: '可用額度調整',
  sub_record_hosting_record: '託管請求',
  sub_action: '動作',
  sub_action_agree: '同意',
  sub_action_refuse: '駁回',
  sub_record_before_action: '操作前值',
  sub_record_after_action: '操作後值',
  sub_record_used: '已用',
  sub_record_remain: '剩餘',
  sub_record_time: '時間',
  sub_record_approver: '審批人',
  sub_record_approver_identity: '審批人身份',
  sub_record_requester: '操作人',
  sub_record_requester_identity: '操作人身份',
  sub_record_quota_title: '可用額度變更記錄',
  sub_record_quota_sub_title: '訂閱號的可用額度變更記錄和消費記錄',
  sub_record_hosting_title: '託管記錄',
  sub_record_hosting_sub_title: '訂閱號的託管變更記錄',
  sub_point_not_set: '無限制',
  support_info: '如果您遇到技術支援問題，請發送電子郵件至',
  system_sitting: '系統設置',
  // t
  tenant_space_role: '租戶空間角色',
  trust_key: '託管服務密鑰',
  time_expire: '到期時間',
  time_inactive: '停用時間',
  time_freeze: '釋放時間',
  time_formal: '轉正時間',
  // u
  used_and_limit: '已使用/限額',
  user_exist_in_sub: '使用者已在此訂閱中存在',
  user_not_found: '使用者不存在',
  user_u: '使用者',
  user_l: '使用者',
  user_manual: '使用者手冊',
  user_management_sub: ' 新建，分配，管理使用者的訂閱號權限和角色',
  unauthorized: '權杖已失效，請重新登入',
  unassigned: '未分配',
  unrestricted: '未限制',
  unconsumed: '未消費',
  // v
  verify_sub_sso: '為了您的安全，我們需要驗證您的身份。 我們已經向{name}{change}發送了驗證碼。',
  verify_code_error: '驗證碼格式錯誤',
  verify_code_policy: '沒有收到簡訊驗證碼？',
  verify_code_p_1: '1. 手機驗證碼存在延遲，可能需要2-3分鐘才能收到，請稍後再試哦。',
  verify_code_p_2: '2. 如2-3分鐘後，仍未收到，請檢查您的手機是否已停止服務，或攔截了我們的簡訊，或簡訊收件箱已滿。',
  verify_code_p_3: '3. 您可以嘗試將SIM卡移動到另一部手機，然後重試，或者聯繫手機運營商諮詢。',
  verify_code_p_4: '4. 當手機遺失、停用或不在身邊時，建議您更換其他驗證方式。',
  verify_identidy: '驗證身份',
  vip_identity: '會員身份',
  // w
  workspaceOwner: '工作空間所有者',
  wise_point: '點數',
  // x
  // y
  yes: '是',
  // z

  // =======================          DB Backup & Restore          =======================
  backup: '備份',
  backup_id: '備份ID',
  db_restore_id: '還原ID',
  input_restore_id: '還原ID',
  input_backup_id: '備份ID',
  backup_name: '備份名稱',
  backup_configuration: '備份配置',
  lowercase_backup_configuration: '備份配置',
  backup_management: '備份管理',
  restore_management: '還原管理',
  backup_schedule: '備份排程',
  lowercase_backup_schedule: '備份排程',
  backup_scheduler: '排程行事曆',
  start_time: '備份開始時間',
  end_time: '備份結束時間',
  backup_size: '備份大小',
  backup_type: '備份類型',
  full_backup: '完整備份',
  select_database_backup: '選擇要備份的資料庫',
  backup_type_full: '備份所有資料庫',
  backup_type_individual: '備份單一資料庫', // '指定需要備份的資料庫列表'
  backup_type_individual_desc: '請選擇資料庫',
  all_status: '所有狀態',
  all_services: '所有服務',
  no_instances: '無實例',
  done: '已完成',
  backing_up: '備份中',
  all_type: '所有類型',
  Full: '完整',
  individual: '單一',
  immediate_backup: '立即備份',
  backup_config_desc: '使用現有的備份配置',
  destination_storage: '選擇作為備份目的地的儲存體',
  destination_storage_validate: '找不到任何儲存體，請先新增至少一個儲存體。',
  advanced: '進階',
  backup_period: '時段',
  shard: 'Shard',
  retention: 'Retention Policy',
  shard_id: 'shard ID',
  retention_placeholder: 'retention policy名稱',
  backup_duration: '備份持續時間',
  restore_duration: '還原持續時間',
  trigger_mode: '觸發模式',
  selected_database: '備份資料庫',
  storage_name: '儲存體名稱',
  storage_type: '儲存體類型',
  advanced_information: '進階資訊',
  view_log: '查看日誌',
  save_settings: '將當前設定另存為新的備份配置',
  // batch_delete: '批次刪除',
  batch_delete_msg: '您確定要刪除這{item}筆',
  data: '資料嗎？',
  restore: '還原',
  stop_backup: '停止備份',
  stop_backup_msg: '您確定要停止備份嗎？',
  restore_confirmation: '確認還原資訊',
  restore_information: '還原資訊',
  restore_policy: '還原策略',
  overwriting_database: '還原時覆蓋現有的資料庫',
  creating_database: '還原時建立新的資料庫',
  restore_note: `#### 請註意：\n1. 在還原過程中不能執行其他備份或還原任務。\n2. 如果在還原過程中有排程任務要進行，則這些排程任務將被跳過。`,
  configuration_name: '配置名稱',
  backup_destination_storage: '儲存體名稱',
  restore_start_time: '還原開始時間',
  restore_end_time: '還原結束時間',
  schedule_name: '排程名稱',
  frequency: '頻率',
  start_backup: '確認開始備份',
  start_backup_with_configuration: '使用以下備份配置開始備份',
  start_according_settings: '備份將按照以下設定啟動',
  edit_config: '編輯備份配置',
  delete_config: '刪除備份配置',
  delete_remark: '以下排程正在使用這個備份配置：',
  delete_remark_s: '以下排程正在使用這個備份配置：',
  delete_warn: '刪除備份配置前請先刪除相依的排程。',
  confirm_delete_no_schedule: '您確定要刪除該備份配置{name}嗎？',
  restore_details: '還原詳情',
  backup_details: '備份詳情',
  stop_restore: '停止還原',
  stop_restore_msg: '您確定要停止還原{item}嗎？',
  add_backup_schedule: '新增備份排程',
  backup_every: '備份每',
  start_at: '開始於',
  edit_backup_schedule: '編輯備份排程',
  cron_time: 'Cron 時間',
  enable_backup_schedule: '啟用備份排程',
  disable_backup_schedule: '停用備份排程',
  enable_backup_schedule_msg: '您確定要{type}該備份排程{item}嗎？',
  storage_settings: '儲存體設定',
  confirm_to_storage_settings: '確認離開本頁，前往{type}頁面？',
  add_storage: '新增儲存體',
  region: '網域',
  access_key: '存取金鑰',
  secret_key: '密鑰',
  test_connection: '測試連接',
  // endpoint: '終端',
  signature_version: '簽章版本',
  NFS_version: '版本',
  NFS_service: 'NFS 服務',
  remote_path: '遠端路徑',
  edit_storage: '編輯儲存體',
  edit_description_placeholder: '請輸入描述',
  download_error: '下載失敗',
  configuration: '配置',
  schedule: '排程',
  manual: '手動',
  storage_backup: '儲存體',

  connection_successful: '連接成功！',
  connection_failed: '連接失敗！',
  add_config: '新增備份配置',
  instance: '實例(s)',
  cron: 'Cron 表示式：',
  no_log: '無日誌資料',
  restore_warn_title: '有正在進行的{type}操作',
  restore_warn_content: '請稍後重試。',
  back_today: '今天',
  schedule_day: '日',
  source_database: '來源資料庫',
  new_database_name: '新資料庫名稱',
  all_database: '<所有資料庫>',

  // Cron component
  week: '週',
  cron_month: '月',
  Mon: '週一',
  Tue: '週二',
  Wed: '週三',
  Thu: '週四',
  Fri: '週五',
  Sat: '週六',
  Sun: '週日',
  Jan: '一月',
  Feb: '二月',
  Mar: '三月',
  Apr: '四月',
  May: '五月',
  Jun: '六月',
  Jul: '七月',
  Aug: '八月',
  Sep: '九月',
  Oct: '十月',
  Nov: '十一月',
  Dec: '十二月',
  cron_start_time: '開始時間',
  cron_end_time: '結束時間',
  time_interval: '時間間隔',
  specify: '指定時間',
  timing_schedule: '定時排程',
  expiry_days: '到期日',
  expiry_time: '到期時間',
  custom_config: '自定義配置',
  schedule_warn: '刪除此備份排程後，正在執行的備份可能會失敗。',
  delete_schedule_msg: '您確定要刪除該備份排程{name}嗎？',
  time_warn: '開始時間必須早於結束時間。',
  backup_configuration_validate: '備份配置不能為空，請先新增備份配置。',
  instance_info: '實例資訊',
  no_upcoming_schedule: '暫無排程',
  database_services: '資料庫服務',
  instance_status: '實例狀態',
  upcoming_schedule: '即將執行的排程',
  max_name_length: '最多可輸入{length}個字元',
  backup_regexp_1: '僅允許 字母 數字 -  且必須以字母或數字開頭',
  backup_regexp_2: '僅允許 字母 數字 . - 且必須以字母或數字開頭和結尾',
  backup_regexp_3: '不允許空白字元',
  delete_backup_management: '刪除備份',
  delete_restore_management: '刪除還原',
  restore_job: '還原',
  delete_storage: '刪除儲存體',
  delete_backup_restore_msg: '您確定要刪除{type}嗎？',
  is_deleted: '已刪除',
  backup_disable: '停用',
  specify_destination: '指定還原目的地',
  all_databases: '<全部資料庫>',
  test_connection_text: '測試連接',
  delete_backup_schedule: '刪除備份排程',
  backup_info: '備份資訊',
  schedule_info: '排程資訊',
  source_all_warn: '被還原的實例必須是初始狀態，若實例中已有資料庫存在，請先移除。',
  protocol_title: '使用者資料庫備份還原服務協議簽署',
  protocol_label: '請仔細閱讀以下服務協議，同意後方可使用WISE-IoTSuite提供的資料庫備份還原服務相關技術服務',
  backup_warn: '備份源資料庫名稱只允許使用 a-z、A-Z、0-9、-，-不得在開頭，上限63字符',
  restore_error_warn: '資料庫還原後需要手動創建Secret，App才可以進行連接',

  // =======================           KubeIot Portal           =======================

  device: '裝置',
  latest_data: '最新資料',
  view_property: '查看屬性',
  devices_devices_detail: '查看屬性',
  summary: '總結',
  subdevice: '子設備',
  gateway: '閘道設備',
  direct: '直連設備',
  tag: '標籤',
  tags: '標籤',
  device_shadow: '設備影子',
  command: '命令',
  device_link: '設備連結',
  devices_detail: '設備詳細資訊',
  devices: '設備',
  devices_desc: '設備說明',
  device_status: '設備狀態',
  client_key: '客戶端金鑰',
  device_auth_type: '設備身份驗證類型',
  product: '產品',
  group: '組',
  please_select_product: '請選擇產品',
  please_select_device: '請選擇設備',
  protocol_type: '通訊協定類型',
  data_format: '資料格式',
  product_name: '產品名稱',
  product_id: '產品識別碼',
  products_list: '產品',
  products_list_desc: '在物聯網平臺中，某一類具有相同能力或特徵的設備的集合被稱為一款產品。',
  device_type: '設備類型',
  smart_manufacturing: '智慧製造',
  smart_industry: '智慧工業',
  smart_medicine: '智慧醫療',
  smart_retail: '智慧零售',
  smart_park: '智慧園區',
  others: '其它',
  manufacturer: '製造商',
  create_product: '建立產品',
  reset_secret: '重置機密',
  device_name: '設備名稱',
  device_id: '設備識別碼',
  gateway_id: '閘道',
  device_twin: '孿生設備',
  item_tips: '{item}說明',
  command_tip: '命令提示',
  synchronous_command_delivery: '同步命令傳遞',
  sync_deliver_command: '同步交付命令',
  asynchronous_command_delivery: '非同步命令傳遞',
  async_deliver_command: '非同步傳遞命令',
  queued_commands: '待處理命令',
  historical_commands: '歷史命令',
  device_secret: '設備金鑰',
  // products: '服務目錄',
  // update_time: '更新時間',
  // secret: '金鑰',
  device_information: '設備資訊',
  access_information: '連線資訊',
  data_escalation: '資料上傳',
  authentication_type: '身份驗證類型',
  authentication_type_tip: `設備認證可確保與平臺的安全連接和安全管理。
    使用金鑰進行身份驗證。
    使用 x.509 憑證進行身份驗證。`,
  add_sub_device: '添加子設備',
  sub_device_tip:
    '顯示通過閘道連接到平臺的設備（感測器）。兒童設備的狀態表示對閘道的訪問狀態，閘道向平台報告狀態以進行更新。如果閘道無法報告子設備的狀態，則平臺上的兒童設備狀態不會更新。',
  certification_type: '認證類型',
  view_history_data: '查看歷史數據',
  reset_secret_tip:
    '重置機密後，原始密件將失效。新密鑰必須在設備上更新，並且設備必須在平臺連接期間攜帶新機密進行身份驗證。您可以在下面的文字框中指定新的金鑰。如果您沒有指定新機密，則平臺會自動生成一個。',
  new_secret: '新金鑰',
  new_secret_tip: '如果您沒有指定此參數，則平臺會自動生成新的金鑰。',
  confirm_new_secret: '確認新金鑰',
  reset_name: '重置名稱',
  no_command_parameters: '無命令參數。',
  duration: '時間',
  choose_command: '選擇命令',
  delivery_policy: '交付政策',
  cache_duration: '緩存持續時間',
  bind_tags: '綁定標籤',
  bind_tags_tip: '綁定標籤，以便於查找特定設備。',
  tag_value: '標記值',
  add_tag: '添加標籤',
  desired_value: '期望值',
  configure_property: '配置屬性',
  device_secert: '設備金鑰',
  sync_command: '交付命令',
  async_command: '交付命令',
  node_id: '節點識別碼',
  // node_type: '節點類型',
  // value: '值'
  registered_devices: '註冊設備數',
  product_detail: '產品詳情',
  property_command: '模型定義',
  module_property: '屬性',
  module_event: '事件',
  service_command: '命令',
  product_module: '模塊',
  product_module_property: '屬性',
  product_module_event: '事件',
  product_module_command: '命令',
  device_property_name: '屬性名稱',
  delete_module: '刪除模塊',
  value_range: '取值範圍',
  unit: '單位',
  length: '長度',
  size: '個數',
  item_type: '類型',
  device_command_name: '命令名稱',
  device_command_params: '下發參數',
  device_command_responses: '響應參數',
  edit_module: '編輯模塊',
  edit_property: '編輯屬性',
  edit_command: '編輯命令',
  edit_event: '編輯事件',
  data_type: '資料類型',
  param_data_name: '下發參數名稱',
  response_data_name: '傳回參數名稱',
  device_service_name: '模塊名稱',
  device_event_name: '事件名稱',
  event_type: '事件類型',
  device_topo_map: '設備拓撲圖',
  cloud: '雲端',
  edge_clouds: '邊緣雲',
  topic_list: 'Topic列表',
  communication_topic: '通信Topic',
  other_communication_topic: '其他服務通信Topic',
  self_communication_topic: '自定義Topic',
  device_group: '設備群組',
  all_groups: '全部群組',
  collect_interval: '',
  report_interval: '',
  extension_config: '擴充元件設定',
  data_synchronism: '資料同步',
  upload_file: '上傳檔案',
  device_data: '設備資料',
  delete_bind_info: '確認要刪除此標籤？',
  delete_sub_device_info: '確認要刪除以下設備？（操作無法復原）',
  delete_revoke_info: '確認要撤銷所需的資產價值？',
  revoke: '撤銷',
  unbind_tip: '確定解除綁定此標籤？',
  delete_device_group_info: '確認要刪除此裝置群組？',
  saving: '儲存中',
  saved: '已儲存',
  define_the_product: '定義產品',
  define_the_product_desc: '具有相同能力或特徵的設備的合集被稱為一款產品',
  register_the_device: '註冊設備',
  register_the_device_desc: '設備建立身份，註冊到平臺的設備，才可以對設備進行管理',
  access_the_device: '設備接入',
  access_the_device_desc: '多種接入方式和接入場景，接入設備支持資料上報、管理控制等',
  create_a_data_pipeline: '建立資料管道',
  create_a_data_pipeline_desc: '通過資料管道，對邊緣端以及雲端資料進行清洗和預處理',
  configure_the_storage: '配置存儲',
  configure_the_storage_desc: '完成資料策略配置，將資料根據實效分為不同的存儲',
  analyze_the_data: '資料分析',
  analyze_the_data_desc: '對清洗過濾後的資料進行分析，有時序分析，即時分析等不同分析方式',
  process_guidance: '流程引導',
  latest_news: '最新動態',
  edge_cloud_rules: '邊緣端規則',
  edge_cloud_rule: '邊緣端規則',
  edge_cloud_rule_forwarding: '資料轉發',
  edge_forwarding: '邊緣端資料轉發',
  rule_name: '規則名稱',
  please_select: '請選擇{type}名稱',

  device_shadow_tip:
    '設備影子是一個 JSON 檔，儲存由設備報告的屬性以及平臺期望交付給設備的屬性。您可以執行命令、提供配置或直接修改此頁面上的數據以修改設備屬性。如果由於設備異常或設備離線而無法交付修改，則修改將在設備連線後生效。如果設備報告的數據是二進位碼串流，則該平臺使用Base64演算法對資料進行加密，並且報告值顯示為加密數據。',
  all_devices: '所有設備',
  use_sub_info: '請使用這些資訊設置連接和資訊報告',
  device_detail: '設備詳細資訊',
  immediate_delivery: '即時交貨',
  these_two_secrets_do_not_match: '這兩個金鑰不相符。',
  group_id: '群組 ID',
  command_type: '命令類型',
  command_id: '命令識別碼',
  command_name: '命令名稱',
  send_time: '發送時間',
  finish_time: '完成時間',
  access_mode: '連接模式',
  reported_value: '報告值',
  desire_value: '期望值',
  json_invalidate: 'JSON 無效',
  upload_device_ext: '上傳設備資訊',
  fit_view: '符合頁面寬度',
  fit_center: '原尺寸置中',
  fit_tip: '看不見？嘗試執行以下兩個功能',
  overviews: '概覽',
  set_device_ext_info: '設備擴充元件資訊',
  device_ext_info_tip: '您可以通過匯入檔案的方式快速設置擴充元件資訊，平臺支援 JSON 格式轉換為設備擴充元件資訊內容。 如需快速匯入請按如下範本編寫檔。',
  device_ext_info_module: '設備擴充元件模組',
  total_products: '產品總數量',
  total_devices: '設備總數量',
  chart_graph: '圖表',
  online_devices: '線上設備數',
  offline_devices: '離線設備數',
  deactivated_devices: '未啟用設備數',
  used: '已使用',
  free: '未使用',
  product_unit: '個',
  device_unit: '臺',
  report_content: '回報內容',
  mqtt_address: 'MQTT 地址',
  output_type: '輸出類型',
  set_datasource: '設定資料來源',
  set_output: '設定輸出',
  old_style: '舊樣式',
  new_style: '新樣式',
  keywords: '關鍵字',
  extension_config_tip: '當前設備未設定擴充元件資訊，請先設定設備擴充元件資訊，擴充元件資訊用於配置設備接入閘道和設備模型定義之間的映射關係。',
  every_times: '每{time}',
  update_extension_config_sucessfully: '擴充元件資訊更新成功',
  device_groups: '設備群組',
  more_kubeiot: '更多',
  discard: '捨棄',
  run: '運行',
  view_switch: '視圖切換',
  ex_co_modules: '展開或收合所有模塊',
  stream_status: '規則狀態',
  create_forwarding_rule: '創建規則轉發',
  set_cleaning_rule: '設置清洗規則',
  set_forwarding_target: '設置轉發目標',
  run_rule: '啟動規則',
  create_stream: '規則',
  worker_id: '端點ID',
  baudrate: '波特率',
  data_bits: '數據位',
  parity: '奇偶校驗',
  stop_bit: '停止位',
  register: '寄存器類型',
  CoilRegister: '線圈寄存器',
  DiscreteInputRegister: '離散寄存器',
  InputRegister: '輸入寄存器',
  HoldingRegister: '保持寄存器',
  offset: '寄存器地址',
  quantity: '數量',
  endianness: '字節序',
  timeout: '超時時間',
  BigEndian: '大端模式',
  BigEndianSwap: '大端交換模式',
  LittleEndian: '小端模式',
  LittleEndianSwap: '小端交換模式',
  device_extension_config: '設備擴展信息',
  property_extension_config: '屬性擴展信息',
  command_extension_config: '命令擴展信息',
  event: '事件',
  no_config: '未配置',
  already_config: '已配置',
  request_data_type: '数据类型',
  request_item_type: '元素數據類型',
  device_protocol: '設備協議',
  inmmediate_delivery: '立即交付',
  unbinding: '解綁',
  report_channel: '設備通過MQTT通道上報消息，需要發送給指定的topic',
  report_format: '上報消息的topic格式：/devices/device_id/sys/properties/report',
  saved_successfully: '儲存成功',
  run_stream: '執行規則',
  stop_stream: '停止規則',
  update_stream: '規則',

  // =======================           AutoIoTSuite        =======================
  synchronization: '同步'
};

export default zh_TW;
